/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Checkbox,
  Collapse,
  Drawer,
  Input,
  Popover,
  Tabs,
  Radio,
  Slider,
  Space,
  Tooltip,
} from "antd";
import React, { useMemo, useState, useEffect, useCallback } from "react";
import TagsInput from "react-tagsinput";
import IsEmpty from "../../../utils/IsEmpty";
import filterSmall from "../../../../assets/filter-small.svg";
import filterSmallWhite from "../../../../assets/WhiteIcons/filterWhite-small.svg";
import search from "../../../../assets/search_icon.svg";
import quickfiltericon from "../../../../assets/quick-filters-icon.svg";
import searchWhite_icon from "../../../../assets/WhiteIcons/searchWhite_icon.svg";
import { DrawerHeader, FilterDrawerContent } from "../../Styles/styles";
import { useDispatch, useSelector } from "react-redux";
import {
  setDeepDiveInfoLoader,
  setFilter,
} from "../../../../redux/actions/DeepDive";
import { setFilterObj } from "../../../../redux/actions/dashboard/Welcome";
import {
  setFilterObj as set_WM_FilterObj,
  setX_attribute,
  setY_attribute,
} from "../../../../redux/actions/WidgetMaker/GraphConfig";

import { getDeepDive } from "../../../../redux/actions/WidgetMaker/WidgetAPI";
import Custom_Attribute from "../../../../assets/Custom_Attribute.svg";

import {
  setFilterApplied,
  setFilterDate,
  setFilterDateActiveKey,
  setisFilterPanelVisible,
  setradioArray,
  setradioChecked,
  setWidgetClearFilter,
  setIsWidgetEdit,
  setChecked,
  setCheckedArray,
  setFilterChange,
} from "../../../../redux/actions/Filter";

import {
  setFilterPanelData,
  setFilterActiveKey,
  setFilterApply,
} from "../../../../redux/actions/Filter";

import Datetime from "../../DateTime";

import Filters from "./Filters";
import {
  callNotification,
  checkForDuplicateWidgets,
  deepCopy,
  getEmptyFieldNotification,
  getFilterDuplicateWidgets,
  getFilterPanelData,
  getPaneIndex,
  getPinnedTemplateDetails,
  getPrivateConversationFilters,
  getUniqueFilters,
  getUpdatedPredefinedFilter,
  getWidgetMakerFlag,
  mergeArrays,
  splitSectionWidgets,
  updateHighchartOptionData,
  getWindowLocationPath,
  getAllFilters,
  useQuery,
  createCommaSeparatedTags,
  addChannelAndBrand,
} from "../../../../redux/constants";
import {
  deleteFilterTemplate,
  duplicateFilterTemplate,
  setFilterTemplate,
  setPinFilterTemplate,
  setUpdateFiltersInSection,
  setUpdateFiltersInWidget,
  setWidgetLoader,
  updateFilterTemplate,
} from "../../../../redux/actions/ApiCall/apiCall";
import {
  setGlobalFilter,
  setDashboardFilters,
  setClearGraphData,
  setPrivateConversation,
  setSelectedPillInPane,
} from "../../../../redux/actions/dashboard/Tab1";
import {
  setClearProfileFiltersSection,
  setFilterObject,
  setTemplateDetails,
  setTemplateFilter,
  setTemplateFiltersObj,
  setTemplateSectionFilter,
  setTemplateWidgetFilter,
} from "../../../../redux/actions/section/section";
import {
  setCompetitorBrandType,
  setDashboardBrandObj,
  setSectionBrandValue,
  setTemplateBrandObj,
  setWidgetBrandValue,
} from "../../../../redux/actions/Template";
import {
  setDashboardDateFilterObj,
  setSectionDateValue,
  setWidgetDateValue,
} from "../../../../redux/actions/DateTime";
import { setOptionHighChart } from "../../../../redux/actions/HighChart";
import { setPdfEditorPanel } from "../../../../redux/actions/scheduleReport/scheduleReport";
import {
  setEditPanel,
  setGlobalSelectedWidgetId,
} from "../../../../redux/actions/dashboard/dashboard";
import {
  setProfileFilterCheckedItems,
  setSelectProfileFilterValue,
} from "../../../../redux/actions/ProfileFilter";
import { setShareSelectedDeepdiveWidget } from "../../../../redux/actions/share/Share";
import {
  setCategoryScreenFilters,
  setClearAllScreenWidgetGraphData,
  setGlobalFiltersInScreen,
  setScreenUpdatedData,
  setStreamScreenBrand,
  setStreamScreenFilters,
  updateScreenWidgetPropdataWithClearGraphData,
} from "../../../../redux/actions/commandCenter/screens/screen";
import { getAllWidgetScreenFilters } from "../../../../redux/constants/commandCenterConstants";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import uuid from "react-uuid";
import TabPane from "antd/lib/tabs/TabPane";
import { QuickFilterTemplate } from "./QuickFilter/QuickFilterTemplate";
import { QuickFilterNotFound } from "./QuickFilter/QuickFilterNotFound";
import { QuickFilterInfoForm } from "./QuickFilter/QuickFilterInfoForm";
import { QuickFilterDeleteModal } from "./QuickFilter/QuickFilterDeleteModal";
import { QuickFilterFooter } from "./QuickFilter/QuickFilterFooter";
import {
  setIsNetworkWidgetSettingEdit,
  setNetworkWidgetSettingObject,
} from "../../../../redux/actions/Network";
import {
  setDeepDiveInfluencersObject,
  setDeepDiveMentionsObject,
  setDeepDiveObject,
} from "../../../../redux/actions/WidgetMaker/WidgetMaker";
import { screensWithPersistedFilters } from "../../../../redux/constants/enums";

const { Panel } = Collapse;

const FilterDrawer = (props) => {
  const {
    onClose,
    filterSearch,
    setfilterSearch,

    filterClearTrigger,
    drawer,
    graph_page,
    type,
    widgetsClearFilter,
    setwidgetsClearFilter,
    isFilterApplied,
    setisFilterApplied,
    widgetMakerClearFilter,
    setWidgetMakerClearFilter,
    editName,
    editAggregation,
    setSearchTerm,
    searchTerm,
    resetDeepdiveDataOnInitial,
    setRadioChecked = () => {}, // passing from editfieldmodal comp
    noteEdited = false,
    setNoteEdited = () => {},
  } = props;
  const { screenId } = useParams();
  let query = useQuery();
  const sectionDetails = useSelector((state) => state.Section.sectionDetails);
  const editPanelInfo = useSelector((state) => state.dashboard?.editPanelInfo);
  const Section = useSelector((state) => state.Section.addSection);
  const templateDetails = useSelector((state) => state.Section.templateDetails);
  const preConfig = useSelector((state) => state.apiCall.configurationData);
  const dispatch = useDispatch();
  const activeKeys = useSelector((state) => state?.Tab1?.activeKey);
  const panes = useSelector((state) => state?.Tab1?.panes);
  const screen = useSelector((state) => state?.Screens?.screen);
  const selectedSection = useSelector((state) => state.Section.filterObject);
  const isDetailedInsightVisible = useSelector(
    (state) => state.DeepDive.isDetailedInsightVisible
  );
  const deepDiveTab = isDetailedInsightVisible?.key;
  const axisPanelAtt = useSelector(
    (state) => state.GraphConfig.widgetGraphConfig
  );
  const temporary_words = useSelector(
    (state) => state.attributes.temporary_words
  );
  const config = useSelector((state) => state.apiCall.config);
  const wm_api_flag = useSelector((state) => state.WidgetMaker.wm_api_flag);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const selectBrandValue = useSelector(
    (state) => state.Template.selectBrandValue
  ); // selected brand values
  const brandCheckedItems = useSelector(
    (state) => state.Template.brandCheckedItems
  ); //checked brand values
  const timeValue = useSelector((state) => state.DateTime.timeValue);
  const filter = useSelector((state) => state.DeepDive.filter);
  const visible = useSelector((state) => state.Filter.isFilterPanelVisible);
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const activeKey1 = useSelector((state) => state.Filter.filterActiveKey);
  const filterObj = useSelector((state) => state.Welcome.graphDetail.filter);
  const activeTabKey = useSelector((state) => state.Tab1.activeKey);
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  //store activekey to enable disable the panel
  const [activeKey, setActiveKey] = useState([]);
  const [preFilterPanelData, setPreFilterPanelData] = useState(null);
  const [attribute, setAttribute] = useState({
    attribute: "",
    shouldContain: [],
    or: [],
    donotHave: [],
  });
  const [textAtt, setTextAtt] = useState([]);
  const [inputVal, setInputVal] = useState({});
  const [inputValArr, setInputValArr] = useState([]);
  const [addColumn, setAddColumn] = useState({
    name: [],
    type: "",
  });
  const [mentionContent, setMentionContent] = useState([]);
  const [addColumnArray, setAddColumnArray] = useState([]);
  const [boolRadioChecked, setBoolRadioChecked] = useState({});
  //set filterdata for panel
  const filterData = useSelector((state) => state.Filter.filterPanelData);
  const filterDateActiveKey = useSelector(
    (state) => state.Filter.filterDateActiveKey
  );
  const deepdive_object = useSelector(
    (state) => state.WidgetMaker.deepdive_object
  );
  const configuration_data = useSelector(
    (state) => state.WidgetAPI.configuration_data
  );
  const data_source = useSelector((state) => state.WidgetLibrary.data_source);

  const graphDetail = useSelector((state) => state.Welcome.graphDetail);
  const opData = useSelector((state) => state.Highchart.Options);

  const allAttributes = useSelector(
    (state) => state?.attributes?.allAttributes
  );
  const All_WM_attributes = useSelector(
    (state) => state.WidgetMaker.All_WM_attributes
  );
  const enteredPlannedValue = useSelector(
    (state) => state?.PlannedValue?.enteredPlannedValue
  );
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const pdfEditorObj = useSelector(
    (state) => state?.scheduleReport?.pdfEditorObj
  );
  let deletedCategoryList = graphConditionConfig?.["deleted_category_mapping"];
  let allAttributesList = allAttributes ? allAttributes : All_WM_attributes;

  const mentions_object = useSelector(
    (state) => state?.WidgetMaker?.deep_dive_mentions_object
  );
  let index = getPaneIndex(panes, activeTabKey);
  const filterTemplatesDetails = panes[index]?.filter_template_details;
  const filterTemplates = filterTemplatesDetails?.filter_templates;
  const pinnedFiltersIds = filterTemplatesDetails?.pinned_filter_templates;
  //setting radio selected key
  const pinnedFilterTemplates = getPinnedTemplateDetails(
    filterTemplates,
    pinnedFiltersIds
  );
  let checkedObj = {};
  const selectedPill = shareTemplateData
    ? shareTemplateData?.selected_pills
    : panes[index]?.selected_pills;
  pinnedFiltersIds?.forEach((id) => {
    checkedObj[id] = true;
  });
  const [slider, setSlider] = useState({});
  const [deep, setDeep] = useState(false);
  const [currentFilterPanelSelected, setcurrentFilterPanelSelected] = useState(
    []
  );

  let pathName = getWindowLocationPath()?.toLowerCase();

  // const [checkedState, setChecked] = useState(null);
  const [checkedValue, setCheckedValue] = useState({
    type: "",
    name: "",
    attribute: "",
    datatype: "",
    data_source: "",
  });
  const [radioValue, setradioValue] = useState({
    type: "",
    name: "",
    attribute: "",
    datatype: "",
    data_source: "",
  });
  const [slideValueobj, setslideValueobj] = useState({
    value: [],
    attribute: "",
    type: "",
    data_source: "",
  });
  const [dateValue, setdateValue] = useState(null);
  const [filterClear, setfilterClear] = useState(false);
  const [checkboxLen, setCheckboxLen] = useState(null);
  const [allValues, setAllValues] = useState(null);
  const [slideArray, setslideArray] = useState([]);
  const [currentTab, setCurrentTab] = useState(
    props?.selectQuickFilter ? "second" : "first"
  );
  const [quickFilterChecked, setQuickFilterChecked] = useState(checkedObj);
  const [selectedCount, setSelectedCount] = useState(
    pinnedFiltersIds?.length || 0
  );
  const [titleInputValue, setTitleInputValue] = useState("");
  const [quickFilterModalVisible, setQuickFilterModalVisible] = useState({
    state: false,
    type: null,
  });
  const [deleteTemplateDetails, setDeleteTemplateDetails] = useState({
    filterTemplate: null,
    showModal: false,
  });
  const [filterTemplatePayload, setFilterTemplatePayload] = useState({
    title: null,
    description: null,
    id: null,
    payload: [],
  });
  const [templateEdit, setTemplateEdit] = useState({
    forEdit: false,
    forDuplicate: false,
    originalTitle: "",
  });
  const [showDescriptionBox, setShowDescriptionBox] = useState(false);
  let dashboardDetails = panes?.[index];
  let showQuickFilter = true;
  if (
    dashboardDetails?.template_type == "ticket" ||
    dashboardDetails?.categorisation === "Tickets"
  ) {
    showQuickFilter = false;
  } else if (
    dashboardDetails.template_id in
    graphConditionConfig?.["realtime_template-global_filters"]
  ) {
    let templates = graphConditionConfig?.["realtime_template-global_filters"];
    if (!templates[dashboardDetails?.template_id]?.length) {
      showQuickFilter = false;
    }
  }
  const handleTabChange = (key) => {
    setCurrentTab(key);
  };
  const handleTemplateCheckboxChange = (e, id) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setSelectedCount(selectedCount + 1);
    } else {
      setSelectedCount(selectedCount - 1);
    }
    setQuickFilterChecked((prev) => ({
      ...prev,
      [id]: isChecked,
    }));
  };
  const handleModalCancel = () => {
    setQuickFilterModalVisible({ ...quickFilterModalVisible, state: false });
    setShowDescriptionBox(false);
  };

  const handleSave = () => {
    let compHiddenPayload = null;
    if (
      !panes[index].private_conversation &&
      panes?.[index]?.template_type === "competition"
    ) {
      let comp_hidden_filter = panes?.[index]?.comp_hidden_filter;
      let global_filters = panes?.[index]?.filters;
      let payloadFilters = filterTemplatePayload?.payload;
      function removeHiddenFromSaved(saved, hidden) {
        hidden?.forEach((hiddenItem) => {
          const savedIndex = saved.findIndex(
            (savedItem) => savedItem.attribute === hiddenItem.attribute
          );

          if (savedIndex > -1) {
            hiddenItem.columns.forEach((hiddenColumn) => {
              const columnIndex = saved[savedIndex].columns.findIndex(
                (savedColumn) => savedColumn.name === hiddenColumn.name
              );

              if (columnIndex > -1) {
                saved[savedIndex].columns.splice(columnIndex, 1);
              }
            });

            if (saved[savedIndex].columns.length === 0) {
              saved.splice(savedIndex, 1);
            }
          }
        });

        return saved;
      }
      compHiddenPayload = removeHiddenFromSaved(
        payloadFilters,
        comp_hidden_filter
      );
    }
    if (
      filterTemplatePayload?.title?.trim() &&
      filterTemplatePayload?.payload?.length > 0
    ) {
      if (quickFilterModalVisible.type === "duplicate") {
        dispatch(
          duplicateFilterTemplate(
            authParams,
            panes,
            index,
            filterTemplatePayload.title,
            filterTemplatePayload.id,
            filterTemplatePayload.description,
            !panes[index].private_conversation &&
              panes?.[index]?.template_type === "competition"
              ? compHiddenPayload
              : filterTemplatePayload.payload
          )
        );
      } else {
        dispatch(
          setFilterTemplate(
            authParams,
            panes,
            index,
            filterTemplatePayload.title,
            filterTemplatePayload.description,
            !panes[index].private_conversation &&
              panes?.[index]?.template_type === "competition"
              ? compHiddenPayload
              : filterTemplatePayload.payload
          )
        );
      }
      setFilterTemplatePayload({
        title: "",
        id: "",
        description: "",
        payload: [],
      });
      setTemplateEdit({
        forEdit: false,
        forDuplicate: false,
        originalTitle: "",
      });
      setQuickFilterModalVisible({ type: null, state: false });
      setCurrentTab("second");
    }
    setShowDescriptionBox(false);
  };
  const templateObj = useSelector((state) => state.scheduleReport.templateObj);

  const radioArray = useSelector((state) => state.Filter.radioArray);

  const radioChecked = useSelector((state) => state.Filter.radioChecked);
  const filterChange = useSelector((state) => state.Filter.filterChange);
  const checkedState = useSelector((state) => state.Filter.checkedState);
  const checkedStateArray = useSelector(
    (state) => state.Filter.checkedStateArray
  );
  const templateDateFilterObj = useSelector(
    (state) => state?.Section?.templateFilterObj
  ); //add in template section and template widget
  const dashboardDateFilterObj = useSelector(
    (state) => state?.DateTime?.dashboardDateFilterObj
  );
  const competitorBrands = useSelector(
    (state) => state.WidgetAPI.competitorBrands?.data?.result
  );
  const dashboardBrandObj = useSelector(
    (state) => state?.Template?.dashboardBrandObj
  ); //add in dashboard section and dashboard widget
  const competitorBrandType = useSelector(
    (state) => state?.Template?.competitorBrandType
  ); //add in templte section
  const dateValue1 = useSelector((state) => state.DateTime.dateValue);
  const templateBrandObj = useSelector(
    (state) => state?.Template?.templateBrandObj
  );
  const clearBrandAndDuration = useSelector(
    (state) => state?.Template?.clearBrandAndDuration
  ); //contains information about clear filter

  const templateLoader = useSelector((state) => state?.apiCall?.templateLoader);
  const visitedWidgetId = useSelector(
    (state) => state?.dashboard?.visited_widget_id
  );
  const dashboardProfileFilterObj = useSelector(
    (state) => state?.Template?.dashboardProfileFilterObj
  ); //add in dashboard section and dashboard widget
  const selectProfileFilterValue = useSelector(
    (state) => state?.ProfileFilter?.selectProfileFilterValue
  );
  const profileFilterCheckedItems = useSelector(
    (state) => state?.ProfileFilter?.profileFilterCheckedItems
  );
  // const profileFilterList = useSelector(
  //   (state) => state?.apiCall?.profile_filter_list
  // );
  const profileFilterList =
    window.location.pathname?.split("/")?.[1] === "edit-dashboard" ||
    window.location.pathname?.split("/")?.[1] === "create-dashboard"
      ? templateDetails?.profile_filters_list
      : panes?.[index]?.profile_filters_list;

  const shareCategory = useSelector((state) => state.ApiCall.shareCategory);
  const shareBrands = useSelector((state) => state.ApiCall.shareBrands);
  const [isDone, setisDone] = useState(false);
  const [isAnyFilterApplied, setAsAnyFilterApplied] = useState(null);
  const [filterSearchTermIndex, setFilterSearchTermIndex] = useState(null);
  const [filterSearchTermE, setFilterSearchTermE] = useState("");
  //add in template section and template widget

  useEffect(() => {
    let activee = [];
    if (filterDateActiveKey !== null) {
      activee.push(filterDateActiveKey);
      activee.push(activeKey1);
    }
    if (activee.length === 2) {
      let activeArray = activee[0].concat(activee[1]);
      setActiveKey(activeArray);
    } else {
      setActiveKey(activeKey1);
    }
  }, [activeKey1, filterDateActiveKey]);

  useEffect(() => {
    if (visible === false) {
      dispatch(setFilterDateActiveKey(null));
    }
  }, [visible]);

  useEffect(() => {
    if (filterClear) {
      updatefilterArray();
      dispatch(setisFilterPanelVisible(false));
      setfilterClear(false);
    }
  }, [templateDetails, filterClear]);

  const getPreDefaultFilters = (filterObj) => {
    let arr1 = [];
    for (let i = 0; i < filterObj?.length; i++) {
      for (let j = 0; j < filterObj[i]?.columns?.length; j++) {
        if (
          filterObj[i].type === "varchar" ||
          filterObj[i].type === "boolean"
        ) {
          arr1.push({
            datatype: filterObj[i]?.type,
            attribute: filterObj[i]?.attribute,
            data_source: filterObj[i]?.data_source || filterObj[i]?.source,
            name: filterObj[i]?.columns[j]?.name,
            type: filterObj[i]?.columns[j]?.type,
          });
        }
      }
    }
    return arr1;
  };

  useEffect(() => {
    if (checkedValue?.attribute !== "") {
      let checkboxArray = {};
      let checkbox =
        checkedStateArray[checkedValue.attribute] &&
        checkedStateArray[checkedValue.attribute]?.length > 0
          ? checkedStateArray[checkedValue.attribute]?.filter((e) => e)
          : [];
      let remFilterData =
        radioArray[type] && radioArray[type]?.data?.length > 0
          ? radioArray[type]?.data?.filter(
              (e) => e.attribute !== checkedValue.attribute
            )
          : [];
      checkboxArray = [...checkbox, ...remFilterData];
      let updateRadioArray = radioArray;
      updateRadioArray[type].data = checkboxArray;
      dispatch(setradioArray(updateRadioArray));
    }
  }, [checkedStateArray]);

  useEffect(() => {
    let index = getPaneIndex(panes, activeTabKey);
    if (
      type === "widgetMaker" ||
      type?.split("_")[0] === "y" ||
      type?.split("_")[0] === "kpi"
    ) {
      let filterPanelData = getFilterPanelData(
        configuration_data[
          data_source === "tickets" || data_source === "page"
            ? "mentions"
            : data_source
        ]?.data,
        false,
        false,
        data_source
      );
      dispatch(setFilterPanelData(filterPanelData));
    } else if (
      (window.location.pathname === "/dashboard" ||
        window.location.pathname === "/pin-dashboard") &&
      (panes[index]?.template_id === "000-000-003" ||
        panes[index]?.template_id === "000-000-002" ||
        panes[index]?.template_id === "000-000-100")
    ) {
      let filterPanelData = getFilterPanelData(
        panes[index]?.filterPanelData,
        panes[index]?.predefined
      );
      let resetChecked = resetCheckedState(
        panes[index]?.filters
          ? panes[index]?.filters
          : panes[index]?.defaultFilters,
        filterPanelData
      );
      dispatch(setChecked(resetChecked));
      dispatch(setFilterPanelData(filterPanelData));
    } else if (
      (window.location.pathname === "/dashboard" ||
        window.location.pathname === "/pin-dashboard") &&
      (panes?.[index]?.sections?.[editPanelInfo?.section_index]?.widgets?.[
        editPanelInfo?.widget_index
      ]?.type === "predefined" ||
        panes?.[index]?.section?.[0]?.widgets?.[editPanelInfo?.widget_index]
          ?.type === "predefined")
    ) {
      let supported_filters = panes?.[index]?.sections
        ? panes?.[index]?.sections?.[editPanelInfo?.section_index]?.widgets?.[
            editPanelInfo?.widget_index
          ]?.supported_filters
        : panes?.[index]?.section?.[0]?.widgets?.[editPanelInfo?.widget_index]
            ?.supported_filters;

      let myArray = config
        ? getFilterPanelData(config, false, supported_filters)
        : getFilterPanelData(config);
      dispatch(setFilterPanelData(myArray));

      let resetChecked = resetCheckedState(
        panes[index]?.filters
          ? panes[index]?.filters
          : panes[index]?.defaultFilters,
        myArray
      );

      //dispatch(setChecked(resetChecked));
    } else if (
      (window.location.pathname?.split("/")?.[1] === "create-dashboard" ||
        window.location.pathname?.split("/")?.[1] === "edit-dashboard") &&
      Section?.[editPanelInfo?.section_index]?.data?.[
        editPanelInfo?.widget_index
      ]?.type === "predefined"
    ) {
      let supported_filters =
        Section?.[editPanelInfo?.section_index]?.data?.[
          editPanelInfo?.widget_index
        ]?.supported_filters;

      let myArray = config
        ? getFilterPanelData(config, false, supported_filters)
        : getFilterPanelData(config);

      dispatch(setFilterPanelData(myArray));
    } else if (
      type === "template_global" ||
      type === "global_dashboard" ||
      type === "share_modal"
    ) {
      let filterPanelData = getFilterPanelData(config);
      dispatch(setFilterPanelData(filterPanelData));
    }
  }, [panes, visible, type]);

  const resetCheckedState = (filterObj, filterData) => {
    let checkedState = {};
    filterObj?.forEach((e) => {
      if (e.type === "varchar") {
        e?.columns?.forEach((el) => {
          if (el?.name === null) {
            filterData?.forEach((g) => {
              if (e.attribute === g.attribute) {
                g?.id?.forEach((f) => {
                  checkedState = {
                    ...checkedState,
                    [g.attribute]: {
                      ...checkedState[g.attribute],
                      [`${g.attribute}#${f?.id}`]: "include",
                    },
                  };
                });
              }
            });
          } else {
            checkedState = {
              ...checkedState,
              [e.attribute]: {
                ...checkedState[e.attribute],
                [`${e.attribute}#${el?.name}`]: "include",
              },
            };
          }
        });
      }
    });
    return checkedState;
  };

  const resetRadioState = (filterObj, filterData) => {
    let radioState = {};

    filterObj?.forEach((e) => {
      if (e.type === "boolean") {
        e?.columns?.forEach((el) => {
          if (el?.name === null) {
            filterData?.forEach((g) => {
              if (e.attribute === g.attribute) {
                g?.id?.forEach((f) => {
                  radioState = {
                    ...radioState,
                    [g.attribute]: "null",
                  };
                });
              }
            });
          } else if (el?.name === 0) {
            radioState = {
              ...radioState,
              [e.attribute]: "exclude",
            };
          } else if (el?.name === 1) {
            radioState = {
              ...radioState,
              [e.attribute]: "include",
            };
          }
        });
      }
    });
    return radioState;
  };

  const resetRadio = (filterObj, filterData) => {
    let radio = {};
    let checkedAll = {};
    let arr1 = [];
    let checkbox = {};
    let checkedArray = {};
    let textAttribute = [];
    let inputVal = {};
    let inputValArr = [];
    if (filterObj && filterObj?.length > 0) {
      for (let i = 0; i < filterObj?.length; i++) {
        if (
          filterObj[i]?.attribute !== "BrandID" &&
          filterObj[i]?.type === "int"
        ) {
          inputVal = {
            ...inputVal,
            [`${filterObj[i]?.attribute}#from`]: filterObj[i]?.columns?.from,
            [`${filterObj[i]?.attribute}#to`]: filterObj[i]?.columns?.to,
          };
          inputValArr = [
            ...inputValArr,
            {
              attribute: filterObj[i]?.attribute,
              data_source: filterObj[i]?.data_source || filterObj[i]?.source,
              type: filterObj[i]?.type,
              columns: {
                from: filterObj[i]?.columns?.from,
                to: filterObj[i]?.columns?.to,
              },
            },
          ];
        } else {
          for (let j = 0; j < filterObj[i]?.columns?.length; j++) {
            if (
              filterObj[i]?.attribute !== "BrandID" &&
              (filterObj[i].type === "varchar" ||
                filterObj[i].type === "boolean")
            ) {
              arr1.push({
                datatype: filterObj[i]?.type,
                attribute: filterObj[i]?.attribute,
                data_source: filterObj[i]?.data_source || filterObj[i]?.source,
                name: filterObj[i]?.columns[j]?.name,
                type: filterObj[i]?.columns[j]?.type,
                display_name: filterObj[i]?.columns[j]?.display_name
                  ? filterObj[i]?.columns[j]?.display_name
                  : null,
              });
              if (filterObj[i].type === "boolean") {
                if (
                  filterObj[i]?.columns[j]?.name === 0 ||
                  filterObj[i]?.columns[j]?.name === "No"
                ) {
                  radio = {
                    ...radio,
                    [`${filterObj[i]?.attribute}`]: "exclude",
                  };
                } else if (
                  filterObj[i]?.columns[j]?.name === 1 ||
                  filterObj[i]?.columns[j]?.name === "Yes"
                ) {
                  radio = {
                    ...radio,
                    [`${filterObj[i]?.attribute}`]: "include",
                  };
                } else if (
                  filterObj[i]?.columns[j]?.name === "null" ||
                  filterObj[i]?.columns[j]?.name === "Any"
                ) {
                  radio = {
                    ...radio,
                    [`${filterObj[i]?.attribute}`]: "null",
                  };
                }
              } else {
                if (filterObj[i]?.columns[j]?.name) {
                  radio = {
                    ...radio,
                    [`${filterObj[i]?.attribute}#${filterObj[i]?.columns[j]?.name}`]:
                      filterObj[i]?.columns[j]?.type,
                  };
                  checkbox = {
                    ...checkbox,
                    [`${filterObj[i]?.attribute}`]: {
                      ...checkbox[`${filterObj[i]?.attribute}`],
                      [`${filterObj[i]?.attribute}#${filterObj[i]?.columns[j]?.name}`]:
                        filterObj[i]?.columns[j]?.type,
                    },
                  };
                  let check = checkedArray[`${filterObj[i]?.attribute}`]
                    ? checkedArray[`${filterObj[i]?.attribute}`]
                    : [];

                  checkedArray = {
                    ...checkedArray,
                    [`${filterObj[i]?.attribute}`]: [
                      ...check,
                      {
                        name: filterObj[i]?.columns[j]?.name,
                        display_name: filterObj[i]?.columns[j]?.display_name
                          ? filterObj[i]?.columns[j]?.display_name
                          : null,
                        type: filterObj[i]?.columns[j]?.type,
                        attribute: filterObj[i]?.attribute,
                        data_source:
                          filterObj[i]?.data_source || filterObj[i]?.source,
                        datatype: filterObj[i]?.type,
                      },
                    ],
                  };
                } else {
                  let values = [];
                  if (!filterObj[i]?.columns[j]?.name) {
                    filterData?.map((el) => {
                      if (el.attribute === filterObj[i]?.attribute)
                        values = el.values;
                    });

                    values?.forEach((item) => {
                      radio = {
                        ...radio,
                        [`${filterObj[i]?.attribute}#${item}`]: "include",
                      };
                    });
                  } else {
                    radio = {
                      ...radio,
                      [`${filterObj[i]?.attribute}#${filterObj[i]?.columns[j]?.name}`]:
                        filterObj[i]?.columns[j]?.type,
                    };
                  }

                  checkbox = {
                    ...checkbox,
                    [`${filterObj[i]?.attribute}`]: {
                      ...checkbox[`${filterObj[i]?.attribute}`],
                      [`${filterObj[i]?.attribute}#${filterObj[i]?.columns[j]?.name}`]:
                        filterObj[i]?.columns[j]?.type,
                    },
                  };
                  let check = checkedArray[`${filterObj[i]?.attribute}`]
                    ? checkedArray[`${filterObj[i]?.attribute}`]
                    : [];

                  checkedArray = {
                    ...checkedArray,
                    [`${filterObj[i]?.attribute}`]: [
                      ...check,
                      {
                        name: filterObj[i]?.columns[j]?.name,
                        display_name: filterObj[i]?.columns[j]?.display_name
                          ? filterObj[i]?.columns[j]?.display_name
                          : null,
                        type: filterObj[i]?.columns[j]?.type,
                        attribute: filterObj[i]?.attribute,
                        data_source:
                          filterObj[i]?.data_source || filterObj[i]?.source,
                        datatype: filterObj[i]?.type,
                      },
                    ],
                  };
                }
              }
            } else if (
              filterObj[i]?.attribute !== "BrandID" &&
              filterObj[i].type === "text"
            ) {
              if (
                textAttribute?.length === 0 ||
                textAttribute?.find(
                  (e) => e?.attribute === filterObj[i]?.attribute
                ) === undefined
              ) {
                textAttribute = [
                  ...textAttribute,
                  {
                    attribute: filterObj[i]?.attribute,
                    [filterObj[i]?.columns[j]?.type === "include"
                      ? `shouldContain`
                      : filterObj[i]?.columns[j]?.type === "exclude"
                      ? `donotHave`
                      : filterObj[i]?.columns[j]?.type === "or" && "or"]:
                      filterObj[i]?.columns[j]?.name,
                  },
                ];
              } else {
                textAttribute = textAttribute?.map((e) => {
                  if (e?.attribute === filterObj[i]?.attribute) {
                    return {
                      ...e,
                      [filterObj[i]?.columns[j]?.type === "include"
                        ? `shouldContain`
                        : filterObj[i]?.columns[j]?.type === "exclude"
                        ? `donotHave`
                        : filterObj[i]?.columns[j]?.type === "or" && "or"]:
                        filterObj[i]?.columns[j]?.name,
                    };
                  } else {
                    return e;
                  }
                });
              }
            }
          }
        }
      }
    }

    return {
      arr: arr1,
      radio: radio,
      checkbox: checkbox,
      checkedAll: checkedAll,
      checkedArray: checkedArray,
      textAttribute: textAttribute,
      inputVal: inputVal,
      inputValArr: inputValArr,
    };
  };

  useEffect(() => {
    if (widgetMakerClearFilter && type === "widgetMaker") {
      setWidgetMakerClearFilter(false);

      dispatch(
        setradioArray({
          ...radioArray,
          global_dashboard: { data: [] },
          dashboard_section: { data: [] },
          dashboard_widget: { data: [] },
          template_global: { data: [] },
          template_section: { data: [] },
          template_widget: { data: [] },
          graph_page: { data: [] },
          orm_dashboard: { data: [] },
          widgetMaker: { data: [] },
          share_modal: { data: [] },
          command_center_global: { data: [] },
          command_center_section: { data: [] },
          command_center_widget: { data: [] },
          deep_dive_global: { data: [] },
        })
      );
      dispatch(
        setradioChecked({
          ...radioChecked,
          global_dashboard: { data: {} },
          dashboard_section: { data: {} },
          dashboard_widget: { data: {} },
          template_global: { data: {} },
          template_section: { data: {} },
          template_widget: { data: {} },
          graph_page: { data: {} },
          orm_dashboard: { data: {} },
          widgetMaker: { data: {} },
          share_modal: { data: {} },
          command_center_global: { data: {} },
          command_center_section: { data: {} },
          command_center_widget: { data: {} },
          deep_dive_global: { data: {} },
        })
      );
      setAttribute({
        attribute: "",
        shouldContain: [],
        or: [],
        donotHave: [],
      });
      dispatch(set_WM_FilterObj([], axisPanelAtt));
      let clearFilterData = filterData?.map((e) => {
        if (e?.is_searchable) {
          return { ...e, values: [] };
        }
        return { ...e };
      });

      setBoolRadioChecked({});

      dispatch(setFilterPanelData(clearFilterData));
    } else if (widgetMakerClearFilter && type.split("_")[0] === "y") {
      setWidgetMakerClearFilter(false);

      dispatch(
        setradioArray({
          ...radioArray,
          y_series_1: { data: [] },
          y_series_2: { data: [] },
          y_series_3: { data: [] },
          y_series_4: { data: [] },
          y_series_5: { data: [] },
        })
      );
      dispatch(
        setradioChecked({
          ...radioChecked,
          y_series_1: { data: {} },
          y_series_2: { data: {} },
          y_series_3: { data: {} },
          y_series_4: { data: {} },
          y_series_5: { data: {} },
        })
      );
      setAttribute({
        attribute: "",
        shouldContain: [],
        or: [],
        donotHave: [],
      });

      let ySeries = {};
      Object.entries(axisPanelAtt?.y_axis).forEach((e) => {
        if (e[0] === axisPanelAtt?.edit_fields?.series) {
          ySeries = {
            ...ySeries,
            [e[0]]: {
              ...e[1],
              filters: [],
            },
          };
        } else {
          ySeries = { ...ySeries, [e[0]]: { ...e[1] } };
        }
      });

      dispatch(
        setY_attribute({
          ...axisPanelAtt,
          [`y_axis`]: { ...ySeries },
          [`edit_fields`]: { ...axisPanelAtt[`edit_fields`], boolValue: true },
          deep_dive_on: null,
        })
      );
    } else if (widgetMakerClearFilter && type.split("_")[0] === "kpi") {
      setWidgetMakerClearFilter(false);

      dispatch(
        setradioArray({
          ...radioArray,
          kpi_card_1: { data: [] },
          kpi_card_2: { data: [] },
          kpi_card_3: { data: [] },
          kpi_card_4: { data: [] },
          kpi_card_5: { data: [] },
          kpi_card_6: { data: [] },
          kpi_card_7: { data: [] },
          kpi_card_8: { data: [] },
          kpi_card_9: { data: [] },
          kpi_card_10: { data: [] },
          kpi_card_11: { data: [] },
          kpi_card_12: { data: [] },
          kpi_card_13: { data: [] },
          kpi_card_14: { data: [] },
          kpi_card_15: { data: [] },
        })
      );
      dispatch(
        setradioChecked({
          ...radioChecked,
          kpi_card_1: { data: {} },
          kpi_card_2: { data: {} },
          kpi_card_3: { data: {} },
          kpi_card_4: { data: {} },
          kpi_card_5: { data: {} },
          kpi_card_6: { data: {} },
          kpi_card_7: { data: {} },
          kpi_card_8: { data: {} },
          kpi_card_9: { data: {} },
          kpi_card_10: { data: {} },
          kpi_card_11: { data: {} },
          kpi_card_12: { data: {} },
          kpi_card_13: { data: {} },
          kpi_card_14: { data: {} },
          kpi_card_15: { data: {} },
        })
      );
      setAttribute({
        attribute: "",
        shouldContain: [],
        or: [],
        donotHave: [],
      });

      let card_settings = [];
      axisPanelAtt?.card_settings?.forEach((el, i) => {
        if (el?.card_name === Number(type?.split("_")[2])) {
          card_settings = [
            ...card_settings,
            { ...el, y_series: { ...el?.y_series, filters: [] } },
          ];
        } else {
          card_settings = [...card_settings, el];
        }
      });

      dispatch(
        setY_attribute({
          ...axisPanelAtt,
          [`card_settings`]: [...card_settings],
          [`edit_fields`]: { ...axisPanelAtt[`edit_fields`], boolValue: false },
          deep_dive_on: null,
        })
      );
    }
    setfilterSearch("");
    dispatch(setFilterActiveKey([]));

    // to clear all states
    setMentionContent({});
    setdateValue({});
    setcurrentFilterPanelSelected([]);
    setradioValue({
      type: "",
      name: "",
      attribute: "",
      datatype: "",
      data_source: "",
    });
    setAttribute({
      attribute: "",
      shouldContain: [],
      or: [],
      donotHave: [],
    });
    setAddColumn({ name: [], type: "" });
    setAddColumnArray([]);
    setTextAtt([]);
    setInputVal({});
    setInputValArr([]);
  }, [widgetMakerClearFilter]);

  useEffect(() => {
    const result = () => {
      if (filterObj?.length > 0) {
        const active = [];
        for (let i = 0; i < filterData?.length; i++) {
          for (let j = 0; j < filterObj?.length; j++) {
            if (filterData[i]?.attribute === filterObj[j]?.attribute) {
              active.push(i);
            }
          }
        }

        dispatch(setFilterActiveKey(active));
      }
    };

    result();
  }, [filterObj, filterData]);

  //ends show filter pills
  //setting default value of datetime

  const onSearch = (e) => {
    setfilterSearch(e.target.value);
    setFilterSearchTermE(e);
  };

  //date state changes

  const ondateChange = (dateStrings) => {
    setdateValue({
      from: dateStrings?.from,
      to: dateStrings?.to,
      attribute: "CreatedDate",
      type: "datetime",
      data_source: "mentions",
    });
  };

  //SLIDER CHANGES
  const onAfterChange = (index, value, name, datatype, datasource) => {
    setSlider({ ...slider, [name]: value });
    setslideValueobj({
      value: value,
      attribute: name,
      datatype: datatype,
      data_source: datasource,
    }); // currently datasource is not passing from child component
  };

  useEffect(() => {
    const addslideArray = () => {
      let a = slideValueobj;
      if (slideValueobj?.type !== "") {
        let myArr = slideArray?.filter((item) => {
          return item?.attribute !== a?.attribute && item?.attribute !== "";
        });
        myArr.push(a);
        setslideArray(myArr);
      }
    };
    addslideArray();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slideValueobj]);

  //code for predefined filter

  const handleSelectAllChange = (
    e,
    attribute,
    dtype,
    id,
    len,
    values,
    displayName,
    dsource
  ) => {
    dispatch(setFilterChange(true));

    const { checked } = e.target;
    setAllValues(values);
    setCheckboxLen(len);
    if (checked && id === null) {
      let checkbox = {};
      let updatCheckedState = { ...checkedState };
      let updateRadioChecked = radioChecked;
      values?.forEach((item) => {
        delete updatCheckedState[`${attribute}#${item?.id ? item?.id : item}`];
        checkbox = {
          ...checkbox,
          [`${attribute}#${item?.id || item?.id === null ? item?.id : item}`]:
            "include",
        };
      });
      updateRadioChecked[type].data = {
        ...updatCheckedState,
        [attribute]: {
          ...checkbox,
        },
      };
      dispatch(setradioChecked(updateRadioChecked));
      setRadioChecked(updateRadioChecked);

      dispatch(
        setChecked({
          ...updatCheckedState,
          [attribute]: {
            ...checkbox,
          },
        })
      );
      setCheckedValue({
        type: "include",
        name: id,
        attribute: attribute,
        datatype: dtype,
        data_source: dsource,
      });
    } else if (!checked && id === null) {
      let checkObj = {};
      let newArr = {};

      let updatCheckedState = { ...checkedState };
      let updateRadioChecked = radioChecked;

      if (
        checkedState?.[attribute] &&
        Object?.keys(checkedState?.[attribute])
      ) {
        Object?.keys(checkedState?.[attribute])
          .filter((item) => item.split("#")[0] !== attribute)
          .forEach((e) => {
            checkObj = { ...checkObj, [e]: "include" };
            newArr = {
              ...newArr,
              [e.split("#")[0]]: { [e]: "include" },
            };
          });
      } else {
        values?.forEach((item) => {
          delete updatCheckedState[
            `${attribute}#${item?.id ? item?.id : item}`
          ];
        });
        updateRadioChecked[type].data = {
          ...updatCheckedState,
          [attribute]: {
            ...checkObj,
          },
        };
        dispatch(setradioChecked(updateRadioChecked));
        setRadioChecked(updateRadioChecked);
      }
      dispatch(
        setChecked({
          ...updatCheckedState,
          [attribute]: { ...checkObj },
        })
      );
      setCheckedValue({
        type: "exclude",
        name: id,
        attribute: attribute,
        datatype: dtype,
        data_source: dsource,
      });
    }
  };

  const handleCheckboxChange = (
    e,
    attribute,
    dtype,
    id,
    len,
    values,
    displayName,
    dsource
  ) => {
    dispatch(setFilterChange(true));

    const { checked } = e.target;
    setAllValues(values);

    setCheckboxLen(len);
    if (checked) {
      if (id === null) {
        let updateRadioChecked = radioChecked;
        updateRadioChecked[type].data = {
          ...radioChecked[type]?.data,
          [`${attribute}#${id}`]: "include",
        };
        dispatch(
          setChecked({
            ...checkedState,
            [attribute]: {
              ...checkedState[attribute],
              [`${attribute}#${id}`]: "include",
            },
          })
        );
        dispatch(setradioChecked(updateRadioChecked));
        setRadioChecked(updateRadioChecked);
      } else {
        let updateRadioChecked = radioChecked;
        updateRadioChecked[type].data = {
          ...radioChecked[type]?.data,
          [`${attribute}#${id}`]: "include",
        };

        let updateChecked = checkedState;
        updateChecked[attribute] = {
          ...checkedState[attribute],
          [`${attribute}#${id}`]: "include",
        };

        if (Object.keys(updateChecked[attribute]).length === len) {
          dispatch(
            setChecked({
              ...updateChecked,
              [attribute]: {
                ...updateChecked[attribute],
                [`${attribute}#null`]: "include",
              },
            })
          );
        } else {
          dispatch(setChecked(updateChecked));
        }
      }

      setCheckedValue({
        type: "include",
        name: id,
        attribute: attribute,
        datatype: dtype,
        display_name: displayName ? displayName : null,
        data_source: dsource,
      });
    } else if (!checked) {
      if (id === null) {
        let checkObj = {};
        let newArr = {};
        Object.keys(checkedState[attribute])
          .filter((item) => item.split("#")[0] !== attribute)
          .forEach((e) => {
            checkObj = { ...checkObj, [e]: "include" };
            newArr = {
              ...newArr,
              [e.split("#")[0]]: { [e]: "include" },
            };
          });
        let updateRadioChecked = radioChecked;
        updateRadioChecked[type].data = {
          ...checkObj,
          [`${attribute}#${id}`]: "include",
        };
        dispatch(setradioChecked(updateRadioChecked));
        setRadioChecked(updateRadioChecked);
        dispatch(
          setChecked({
            ...newArr,
            [attribute]: { [`${attribute}#${id}`]: "include" },
          })
        );
      } else {
        if (
          checkedState?.[attribute] &&
          Object?.keys(checkedState?.[attribute])?.length === 0
        ) {
          let updateCheckedState = checkedState;
          updateCheckedState = {
            ...checkedState,
          };
          let updateRadioChecked = radioChecked;
          updateRadioChecked[type].data = {
            ...radioChecked[type]?.data,
          };
          let name = `${attribute}#${id}`;
          delete updateRadioChecked[type].data[name];
          delete updateCheckedState[attribute][name];

          updateRadioChecked[type].data = {
            ...updateRadioChecked[type].data,
            [`${attribute}#null`]: "include",
          };
          dispatch(
            setChecked({
              ...updateCheckedState,
              [attribute]: { [`${attribute}#null`]: "include" },
            })
          );
          dispatch(setradioChecked(updateRadioChecked));
          setRadioChecked(updateRadioChecked);
        } else {
          let updateCheckedState = checkedState;
          updateCheckedState = {
            ...checkedState,
          };
          let updateRadioChecked = radioChecked;
          updateRadioChecked[type].data = {
            ...radioChecked[type]?.data,
          };
          let name = `${attribute}#${id}`;
          let name1 = `${attribute}#null`;

          delete updateRadioChecked[type].data[name];
          if (updateCheckedState?.[attribute]?.[name])
            delete updateCheckedState[attribute][name];
          else delete updateCheckedState[name];
          if (updateCheckedState?.[attribute]?.[name1])
            delete updateCheckedState[attribute][name1];

          dispatch(setChecked(updateCheckedState));
          dispatch(setradioChecked(updateRadioChecked));
          setRadioChecked(updateRadioChecked);
        }
      }

      setCheckedValue({
        type: "exclude",
        name: id,
        attribute: attribute,
        datatype: dtype,
        display_name: displayName ? displayName : null,
        data_source: dsource,
      });
    }
  };

  const handleRadioOptionsChange = (e, attribute, dtype, id, dsource) => {
    if (id === 1 || id === "Yes") {
      let updateRadioChecked = radioChecked;
      updateRadioChecked[type].data = {
        ...radioChecked[type]?.data,
        [`${attribute}#${id}`]: "include",
      };
      setBoolRadioChecked({
        ...boolRadioChecked,
        [`${attribute}`]: "include",
      });
      dispatch(setradioChecked(updateRadioChecked));
      setradioValue({
        type: e.target.value,
        name: id,
        attribute: attribute,
        datatype: dtype,
        data_source: dsource,
      });
      setRadioChecked(updateRadioChecked);
    } else if (id === 0 || id === "No") {
      let updateRadioChecked = radioChecked;
      updateRadioChecked[type].data = {
        ...radioChecked[type]?.data,
        [`${attribute}#${id}`]: "exclude",
      };
      setBoolRadioChecked({
        ...boolRadioChecked,
        [`${attribute}`]: "exclude",
      });
      dispatch(setradioChecked(updateRadioChecked));
      setradioValue({
        type: e.target.value,
        name: id,
        attribute: attribute,
        datatype: dtype,
        data_source: dsource,
      });
      setRadioChecked(updateRadioChecked);
    } else if (id === "null" || id === "Any") {
      let updateRadioChecked = radioChecked;
      updateRadioChecked[type].data = {
        ...radioChecked[type]?.data,
        [`${attribute}#${id}`]: "null",
      };
      setBoolRadioChecked({
        ...boolRadioChecked,
        [`${attribute}`]: "null",
      });
      dispatch(setradioChecked(updateRadioChecked));
      setradioValue({
        type: e.target.value,
        name: "null",
        attribute: attribute,
        datatype: dtype,
        data_source: dsource,
      });
      setRadioChecked(updateRadioChecked);
    }
    setCheckedValue({
      type: "include",
      name: id,
      attribute: attribute,
      datatype: dtype,
      data_source: dsource,
    });
  };

  // INPUT VAL  CHANGES

  const onInputValChanges = (e, att, type, dsource) => {
    if (e?.target?.value?.length > 10) return;
    const inputData =
      inputValArr?.length === 0 ||
      !inputValArr?.some((el) => el?.attribute === att)
        ? [
            ...inputValArr,
            {
              attribute: att,
              type: type,
              data_source: dsource,
              columns: {
                from:
                  e.target.id.split("#")[1] === "from" ? e.target.value : "0",
                to: e.target.id.split("#")[1] === "to" ? e.target.value : "0",
              },
            },
          ]
        : inputValArr?.map((el) => {
            if (el?.attribute === att) {
              let obj = { ...el };
              obj.columns = {
                from:
                  e.target.id.split("#")[1] === "from"
                    ? e.target.value
                    : el?.columns?.from,
                to:
                  e.target.id.split("#")[1] === "to"
                    ? e.target.value
                    : el?.columns?.to,
              };

              return obj;
            } else {
              return el;
            }
          });
    setInputValArr(inputData);
    setInputVal({
      ...inputVal,
      [e.target.id]: e.target.value,
    });
  };

  // RADIO BUTTON CHANGES
  const onradioChange = (
    e,
    name,
    attribute,
    dtype,
    id,
    displayName,
    dsource
  ) => {
    dispatch(setFilterChange(true));
    let checked = e?.target?.checked;
    if (checked) {
      let updateRadioChecked = radioChecked;
      updateRadioChecked[type].data = {
        ...radioChecked?.[type]?.data,
        [`${attribute}#${
          type === "widgetMaker" ||
          type?.split("_")[0] === "kpi" ||
          type?.split("_")[0] === "y"
            ? name
            : panes[index].predefined &&
              panes[index]?.template_type === "ticket" &&
              panes[index].template_id === "000-000-002" &&
              panes[index].template_id === "000-000-003"
            ? id
            : name
        }`]: e.target.value,
        // display_name: displayName ? displayName : null,
      };
      dispatch(setradioChecked(updateRadioChecked));
      setRadioChecked(updateRadioChecked);
      setradioValue({
        type: e.target.value,
        name:
          type === "widgetMaker" ||
          type?.split("_")[0] === "kpi" ||
          type?.split("_")[0] === "y"
            ? name
            : panes[index].predefined &&
              panes[index]?.template_type === "ticket" &&
              panes[index].template_id === "000-000-002" &&
              panes[index].template_id === "000-000-002"
            ? id
            : name,
        attribute: attribute,
        datatype: dtype,
        data_source: dsource,
        display_name: displayName ? displayName : null,
      });
      setRadioChecked(updateRadioChecked);
    } else if (!checked) {
      let updateRadioChecked = radioChecked;
      let filterdCheckedBox = {};
      Object?.keys(updateRadioChecked[type]?.data)
        ?.filter((el) => {
          return el !== `${attribute}#${name}`;
        })
        ?.forEach((e) => {
          filterdCheckedBox = {
            ...filterdCheckedBox,
            [e]: updateRadioChecked[type]?.data[e],
          };
        });

      updateRadioChecked[type].data = {
        ...filterdCheckedBox,
      };
      dispatch(setradioChecked({ ...updateRadioChecked }));
      dispatch(
        setradioArray({
          ...radioArray,
          [type]: {
            [`data`]: [
              ...radioArray?.[type]?.data?.filter((el) => el?.name !== name),
            ],
          },
        })
      );
      setRadioChecked({ ...updateRadioChecked });
    }
  };

  //making array of every radiovalue object
  useEffect(() => {
    const addRadioobject = () => {
      let a = radioValue;
      if (type && radioValue?.type !== "") {
        let myArr = Array.isArray(radioArray[type]?.data)
          ? radioArray[type]?.data
          : [];

        if (a.datatype === "boolean")
          myArr = myArr?.filter((item) => {
            if (item.attribute === a.attribute) return null;
            else return item;
          });
        if (a.datatype !== "boolean")
          myArr = myArr?.filter((item) => {
            if (item?.attribute === a?.attribute) {
              return item?.name !== a?.name && item?.name !== "";
            } else {
              return item;
            }
          });

        myArr?.push(a);

        let updateRadioArray = radioArray;
        updateRadioArray[type].data = myArr;
        dispatch(setradioArray(updateRadioArray));
      }
    };
    addRadioobject();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [radioValue]);

  // making array of every checkedValue object
  useEffect(() => {
    const addCheckedObject = () => {
      let a = checkedValue;

      if (checkedValue?.type !== "" && checkedValue?.datatype !== "boolean") {
        if (checkedValue?.type === "include") {
          if (a.name === null) {
            let updateCheckedArray = checkedStateArray;
            if (checkedStateArray?.[a.attribute]) {
              checkedStateArray[a.attribute]?.map((e) => {
                updateCheckedArray[a.attribute] = checkedStateArray[
                  a.attribute
                ].filter((e) => e.attribute !== a.attribute);
                dispatch(
                  setCheckedArray({
                    ...updateCheckedArray,
                    [a.attribute]: [...updateCheckedArray[a.attribute], a],
                  })
                );
              });
            } else {
              dispatch(
                setCheckedArray({
                  ...updateCheckedArray,
                  [a.attribute]: [a],
                })
              );
            }
          } else {
            let updateCheckedArray = checkedStateArray;
            if (checkedStateArray[a.attribute]?.some((e) => e.name === null)) {
              updateCheckedArray[a.attribute] = checkedStateArray[
                a.attribute
              ].filter((e) => e.name !== null);
              dispatch(
                setCheckedArray({
                  ...updateCheckedArray,
                  [a.attribute]: [...updateCheckedArray[a.attribute], a],
                  display_name: a?.displayName ? a?.displayName : null,
                })
              );
            } else if (checkedStateArray[a.attribute]) {
              updateCheckedArray[a.attribute] = [
                ...updateCheckedArray[a.attribute],
                a,
              ];

              if (
                allValues?.some((e) => e.id === null) &&
                updateCheckedArray[a?.attribute]?.length === checkboxLen
              ) {
                let add = {
                  name: null,
                  attribute: a?.attribute,
                  data_source: a?.data_source || a?.source,
                  datatype: a?.datatype,
                  type: "include",
                };
                updateCheckedArray[a.attribute] = checkedStateArray[
                  a.attribute
                ].filter((e) => e.attribute !== a.attribute);
                dispatch(
                  setCheckedArray({
                    ...updateCheckedArray,
                    [a.attribute]: [...updateCheckedArray[a.attribute], add],
                    display_name: a?.displayName ? a?.displayName : null,
                  })
                );
              } else {
                dispatch(
                  setCheckedArray({
                    ...updateCheckedArray,
                    [a.attribute]: [...updateCheckedArray[a.attribute]],
                    display_name: a?.displayName ? a?.displayName : null,
                  })
                );
              }
            } else {
              updateCheckedArray = {
                ...updateCheckedArray,
                [a.attribute]: [a],
              };
              dispatch(setCheckedArray(updateCheckedArray));
            }
          }
        } else if (checkedValue?.type === "exclude") {
          if (a.name === null) {
            checkedStateArray[a.attribute]?.map((e) => {
              let updateCheckedArray = checkedStateArray;
              updateCheckedArray[a.attribute] = checkedStateArray[
                a.attribute
              ].filter((e) => e.attribute !== a.attribute);

              dispatch(
                setCheckedArray({
                  ...updateCheckedArray,
                })
              );
            });
          } else {
            let updateCheckedArray = checkedStateArray;

            if (
              checkedStateArray?.[a?.attribute]?.some((e) => e.name === null)
            ) {
              let filter = allValues
                ?.filter((e) => e.id !== null)
                ?.filter((el) => el.id !== a.name)
                ?.map((item) => {
                  return {
                    name: item?.id,
                    attribute: a?.attribute,
                    datatype: a?.datatype,
                    data_source: a?.data_source || a?.source,
                    type: "include",
                    display_name:
                      panes?.[index]?.template_id === "000-000-002" &&
                      item?.name
                        ? item.name
                        : null,
                  };
                });
              dispatch(
                setCheckedArray({
                  ...updateCheckedArray,
                  [a.attribute]: filter ? [...filter] : [],
                })
              );
            } else if (
              checkedStateArray?.[a?.attribute]?.some((e) => e.name === a.name)
            ) {
              let updateCheckedArray = checkedStateArray;
              updateCheckedArray[a.attribute] = checkedStateArray[
                a.attribute
              ].filter((e) => e.name !== a.name);

              if (
                allValues?.some((e) => e.id === null) &&
                updateCheckedArray[a.attribute].length === 0
              ) {
                let addOn = {
                  name: null,
                  attribute: a.attribute,
                  datatype: a.datatype,
                  data_source: a?.data_source || a?.source,
                  type: "include",
                };
                dispatch(
                  setCheckedArray({
                    ...updateCheckedArray,
                    [a.attribute]: [...updateCheckedArray[a.attribute], addOn],
                  })
                );
              } else {
                dispatch(
                  setCheckedArray({
                    ...updateCheckedArray,
                    [a.attribute]: [...updateCheckedArray[a.attribute]],
                  })
                );
              }
            }
          }
        }
      } else if (
        checkedValue?.type !== "" &&
        checkedValue?.datatype === "boolean"
      ) {
        let updateDefaultFilter = radioArray[type].data?.filter((el) => {
          if (el.attribute === a.attribute) {
            return {
              ...el,
              name: a.name === "null" ? null : a.name,
            };
          } else {
            return { ...el };
          }
        });
        updateDefaultFilter = updateDefaultFilter?.filter((el) => {
          return el?.name !== "null";
        });
        let updateRadioArray = radioArray;
        updateRadioArray[type].data = updateDefaultFilter;
        dispatch(setradioArray(updateRadioArray));
      }
    };
    addCheckedObject();
  }, [checkedValue]);
  useEffect(() => {
    let index = getPaneIndex(panes, activeKeys);
    let textColumns = textAtt?.map((e) => {
      return {
        attribute: e?.attribute,
        data_source: e?.data_source || e?.source,
        type: "text",
        columns: [
          {
            name: e?.shouldContain === undefined ? [] : e?.shouldContain,
            type: "include",
          },
          {
            name: e?.donotHave === undefined ? [] : e?.donotHave,
            type: "exclude",
          },
          { name: e?.or === undefined ? [] : e?.or, type: "or" },
        ],
      };
    });
    setAddColumnArray(textColumns);
  }, [textAtt]);

  const getCommandCenterWidgetData = (
    sectionIndex,
    screenData,
    widgetIndex
  ) => {
    if (sectionIndex >= 0 && screenData?.sections) {
      return screenData?.sections[sectionIndex]?.widgets?.[widgetIndex];
    } else if (sectionIndex === null && screenData?.section[0]?.widgets) {
      return screenData?.section[0]?.widgets?.[widgetIndex];
    } else {
      return screenData?.widgets?.[widgetIndex];
    }
  };

  const onSubmit = () => {
    setisDone(true);
    dispatch(setFilterDateActiveKey(null));
    let check = updatefilterArray();
    !check && drawer && onClose();
    dispatch(setFilterChange(false));
    dispatch(setTemplateBrandObj(null));
    dispatch(setTemplateFiltersObj(null));
  };

  useEffect(() => {
    if (isFilterApplied) {
      let check = updatefilterArray();
      dispatch(setFilterChange(false));
      setisFilterApplied(false);
    }
  }, [isFilterApplied]);
  //Logic of filter panel
  const updatefilterArray = () => {
    let validationError = false;
    let result2 = [];

    let data = radioArray[type]?.data;

    var myMap = new Map();
    if (data?.length) {
      for (let i in data) {
        if (myMap?.has(data[i]?.attribute)) {
          let value = myMap.get(data[i]?.attribute);
          let columnsArray = value.columns; // copy columns array
          columnsArray?.push({
            name: data[i]?.name,
            type: data[i]?.type,
            display_name: data[i]?.display_name ? data[i]?.display_name : null,
          });

          myMap.set(data[i]?.attribute, {
            attribute: data[i]?.attribute,
            type: data[i]?.datatype,
            data_source: data[i]?.data_source || data[i]?.source,
            columns: columnsArray,
          });
        } else {
          myMap.set(data[i]?.attribute, {
            attribute: data[i]?.attribute,
            type: data[i]?.datatype,
            data_source: data[i]?.data_source || data[i]?.source,
            columns: [
              {
                name: data[i]?.name,
                type: data[i]?.type,
                display_name: data[i]?.display_name
                  ? data[i]?.display_name
                  : null,
              },
            ],
          });
        }
      }

      for (const [, value] of myMap.entries()) {
        result2.push(value);
      }
    }
    let data2 = slideArray;

    var myMap2 = new Map();

    for (let i in data2) {
      if (myMap2.has(data2[i]?.attribute)) {
        let value = myMap.get(data[i]?.attribute);
        let columnsArray = value?.columns; // copy columns array
        columnsArray?.push({
          from: data2[i]?.value[0]?.toString(),
          to: data2[i]?.value[1]?.toString(),
        });

        myMap2.set(data2[i].attribute, {
          attribute: data2[i].attribute,
          type: data2[i].datatype,
          data_source: data2[i]?.data_source || data2[i]?.source,
          columns: columnsArray,
        });
      } else {
        myMap2.set(data2[i].attribute, {
          attribute: data2[i].attribute,
          type: data2[i].datatype,
          data_source: data2[i]?.data_source || data2[i]?.source,
          columns: {
            from: data2[i]?.value[0]?.toString(),
            to: data2[i]?.value[1]?.toString(),
          },
        });
      }
    }

    for (const [, value] of myMap2.entries()) {
      result2.push(value);
    }

    //date obj
    if (dateValue?.attribute) {
      let data3 = dateValue;

      const col = [data3]
        .filter((e) => e !== null && e.from !== "Invalid date")
        .map((e) => {
          let data = [];
          let data1 = {
            from: e.from,
            to: e.to,
          };
          data.push(data1);
          return data1;
        });

      let result_date = {
        attribute: "CreatedDate",
        type: "datetime",
        columns: {
          from: col?.length !== 0 && col[0].from,
          to: col?.length !== 0 && col[0].to,
        },
      };

      if (result_date?.columns?.from !== false) {
        result2.push(result_date);
        dispatch(setFilterApply(true));
      } else {
        dispatch(setFilterApply(false));
        dispatch(setFilterObj(null, graphDetail));
      }
    }

    //int type
    if (inputValArr?.length > 0) {
      inputValArr?.forEach((el) => {
        if (
          el?.columns?.from &&
          Number(el?.columns?.from) !== 0 &&
          Number(el?.columns?.from) > Number(el?.columns?.to)
        ) {
          callNotification(
            "In " +
              allAttributesList?.[el?.attribute] +
              ' "From" should be less than "To"',
            "info"
          );
          validationError = true;
        }
        if (!el?.columns?.from || !el?.columns?.to) {
          callNotification(
            "In " +
              allAttributesList?.[el?.attribute] +
              " From or To should not be empty",
            "info"
          );
          validationError = true;
        }
        result2.push({
          attribute: el?.attribute,
          type: "int",
          data_source: el?.data_source || el?.source,
          columns: {
            from: el?.columns?.from,
            to: el?.columns?.to,
          },
        });
      });
    }
    //Description
    if (addColumnArray?.length > 0) {
      let final = addColumnArray?.map((el) => {
        return {
          attribute: el?.attribute,
          data_source: el?.data_source || el?.source,
          type: "text",
          columns: el?.columns?.filter((e) => e?.name?.length > 0),
        };
      });
      if (final?.[0]?.columns?.length) {
        final?.forEach((el) => {
          result2.push(el);
        });
      }
    }
    let myArr = result2.filter((item) => {
      return (
        item.attribute !== "" &&
        item.attribute !== undefined &&
        item.columns !== undefined
      );
    });
    myArr = myArr?.filter(
      (f) =>
        (Array.isArray(deletedCategoryList) &&
          !deletedCategoryList?.includes(f?.attribute)) || // Keep if not in excluded list
        (Array.isArray(deletedCategoryList) &&
          deletedCategoryList?.includes(f?.attribute) &&
          f?.columns[0]?.type !== "exclude")
    );
    if (panes?.[index]?.template_id === "000-000-002") {
      myArr = addChannelAndBrand(deepCopy(myArr), deepCopy(filterData));
    }
    !validationError && passFilterObj(myArr);
    if (validationError) {
      // to close or collapse accordion list
      dispatch(setFilterActiveKey([]));
      return validationError;
    }
  };

  const createFilteredArray = () => {
    let validationError = false;
    let result2 = [];

    let data = radioArray[type]?.data;

    var myMap = new Map();
    if (data?.length) {
      for (let i in data) {
        if (myMap?.has(data[i]?.attribute)) {
          let value = myMap.get(data[i]?.attribute);
          let columnsArray = value.columns; // copy columns array
          columnsArray?.push({
            name: data[i]?.name,
            type: data[i]?.type,
            display_name: data[i]?.display_name ? data[i]?.display_name : null,
          });

          myMap.set(data[i]?.attribute, {
            attribute: data[i]?.attribute,
            type: data[i]?.datatype,
            data_source: data[i]?.data_source || data[i]?.source,
            columns: columnsArray,
          });
        } else {
          myMap.set(data[i]?.attribute, {
            attribute: data[i]?.attribute,
            type: data[i]?.datatype,
            data_source: data[i]?.data_source || data[i]?.source,
            columns: [
              {
                name: data[i]?.name,
                type: data[i]?.type,
                display_name: data[i]?.display_name
                  ? data[i]?.display_name
                  : null,
              },
            ],
          });
        }
      }

      for (const [, value] of myMap.entries()) {
        result2.push(value);
      }
    }
    let data2 = slideArray;

    var myMap2 = new Map();

    for (let i in data2) {
      if (myMap2.has(data2[i]?.attribute)) {
        let value = myMap.get(data[i]?.attribute);
        let columnsArray = value?.columns; // copy columns array
        columnsArray?.push({
          from: data2[i]?.value[0]?.toString(),
          to: data2[i]?.value[1]?.toString(),
        });

        myMap2.set(data2[i].attribute, {
          attribute: data2[i].attribute,
          type: data2[i].datatype,
          data_source: data2[i]?.data_source || data2[i]?.source,
          columns: columnsArray,
        });
      } else {
        myMap2.set(data2[i].attribute, {
          attribute: data2[i].attribute,
          type: data2[i].datatype,
          data_source: data2[i]?.data_source || data2[i]?.source,
          columns: {
            from: data2[i]?.value[0]?.toString(),
            to: data2[i]?.value[1]?.toString(),
          },
        });
      }
    }

    for (const [, value] of myMap2.entries()) {
      result2.push(value);
    }

    //date obj
    if (dateValue?.attribute) {
      let data3 = dateValue;

      const col = [data3]
        .filter((e) => e !== null && e.from !== "Invalid date")
        .map((e) => {
          let data = [];
          let data1 = {
            from: e.from,
            to: e.to,
          };
          data.push(data1);
          return data1;
        });

      let result_date = {
        attribute: "CreatedDate",
        type: "datetime",
        columns: {
          from: col?.length !== 0 && col[0].from,
          to: col?.length !== 0 && col[0].to,
        },
      };

      if (result_date?.columns?.from !== false) {
        result2.push(result_date);
      }
    }

    //int type
    if (inputValArr?.length > 0) {
      inputValArr?.forEach((el) => {
        if (
          el?.columns?.from &&
          Number(el?.columns?.from) !== 0 &&
          Number(el?.columns?.from) > Number(el?.columns?.to)
        ) {
          callNotification(
            "In " +
              allAttributesList?.[el?.attribute] +
              ' "From" should be less than "To"',
            "info"
          );
          validationError = true;
        }
        if (!el?.columns?.from || !el?.columns?.to) {
          callNotification(
            "In " +
              allAttributesList?.[el?.attribute] +
              " From or To should not be empty",
            "info"
          );
          validationError = true;
        }
        result2.push({
          attribute: el?.attribute,
          type: "int",
          data_source: el?.data_source || el?.source,
          columns: {
            from: el?.columns?.from,
            to: el?.columns?.to,
          },
        });
      });
    }
    //Description
    if (addColumnArray?.length > 0) {
      let final = addColumnArray?.map((el) => {
        return {
          attribute: el?.attribute,
          type: "text",
          data_source: el?.data_source || el?.source,
          columns: el?.columns?.filter((e) => e?.name?.length > 0),
        };
      });
      if (final?.[0]?.columns?.length) {
        final?.forEach((el) => {
          result2.push(el);
        });
      }
    }
    let myArr = result2.filter((item) => {
      return (
        item.attribute !== "" &&
        item.attribute !== undefined &&
        item.columns !== undefined
      );
    });

    if (validationError) {
      // to close or collapse accordion list
      dispatch(setFilterActiveKey([]));
      return validationError;
    }
    setFilterTemplatePayload({ ...filterTemplatePayload, payload: myArr });
    return myArr;
  };

  //Logic of filter panels
  const passFilterObj = (value) => {
    if (graph_page) {
      dispatch(setFilterObj(value, graphDetail));
    }
    if (type === "widgetMaker") {
      let y_series_flag = getWidgetMakerFlag(axisPanelAtt, wm_api_flag);
      if (!y_series_flag?.flag) {
        dispatch(set_WM_FilterObj(value, axisPanelAtt));
      } else {
        resetState();
        getEmptyFieldNotification();
      }
    }
    if (type?.split("_")[0] === "y") {
      let y_series_flag = getWidgetMakerFlag(axisPanelAtt, wm_api_flag);
      if (!y_series_flag?.flag) {
        let ySeries = {};
        Object.entries(axisPanelAtt?.y_axis).forEach((e) => {
          if (e[0] === type) {
            ySeries = {
              ...ySeries,
              [e[0]]: {
                ...e[1],
                filters: value,
                trace_name: editName,
                aggregation: editAggregation,
              },
            };
          } else {
            ySeries = { ...ySeries, [e[0]]: { ...e[1] } };
          }
        });
        dispatch(
          setY_attribute({
            ...axisPanelAtt,
            [`y_axis`]: { ...ySeries },
            [`edit_fields`]: {
              ...axisPanelAtt[`edit_fields`],
              boolValue: false,
            },
            deep_dive_on: null,
          })
        );
      } else {
        dispatch(
          setY_attribute({
            ...axisPanelAtt,

            [`edit_fields`]: {
              ...axisPanelAtt[`edit_fields`],
              boolValue: false,
            },
            deep_dive_on: null,
          })
        );
        getEmptyFieldNotification();
      }
    }
    if (type?.split("_")[0] === "kpi") {
      let y_series_flag = getWidgetMakerFlag(axisPanelAtt, wm_api_flag);
      if (!y_series_flag?.flag) {
        let card_settings = [];
        axisPanelAtt?.card_settings?.forEach((el, i) => {
          if (el?.card_name === Number(type?.split("_")[2])) {
            card_settings = [
              ...card_settings,
              {
                ...el,
                y_series: {
                  ...el?.y_series,
                  filters: value,
                  trace_name: editName,
                  aggregation: editAggregation,
                },
              },
            ];
          } else {
            card_settings = [...card_settings, el];
          }
        });
        dispatch(
          setY_attribute({
            ...axisPanelAtt,
            [`card_settings`]: [...card_settings],
            [`edit_fields`]: {
              ...axisPanelAtt[`edit_fields`],
              boolValue: false,
            },
            deep_dive_on: null,
          })
        );
      } else {
        dispatch(
          setY_attribute({
            ...axisPanelAtt,

            [`edit_fields`]: {
              ...axisPanelAtt[`edit_fields`],
              boolValue: false,
            },
            deep_dive_on: null,
          })
        );
        getEmptyFieldNotification();
      }
    }
    dispatch(setFilter(null));
    if (selectedSection?.type === "template_global") {
      let global = templateDetails?.templateFilters
        ? templateDetails?.templateFilters
        : [];
      let templateObject = {
        filters: value,
        //get brands from tempdetails	//for brand group value
        brands: templateDetails?.templateBrands?.columns
          ? templateDetails?.templateBrands?.columns
          : templateDetails?.templateBrands?.length > 0
          ? templateDetails?.templateBrands
          : brandlogicalgroup?.length > 0
          ? brandlogicalgroup
          : brands,
        authParams: authParams,
        templateDetails: templateDetails,
        section: Section,
        type: "template_global",
        currentFilter: templateDetails?.templateFiltersvalue
          ? templateDetails?.templateFiltersvalue
          : value
          ? value
          : [],
        duration: templateDetails?.templateDuration
          ? templateDetails?.templateDuration
          : null,
        //for brand group value
        selectBrands:
          templateDetails?.templateBrands?.columns ||
          templateDetails?.templateBrands?.length > 0
            ? templateDetails?.templateBrands
            : false,
        graphConditionConfig: graphConditionConfig,
      };

      if (filterClear) {
        let filters = [];
        let comp_hidden_filter =
          templateDetails?.comp_hidden_filter &&
          !templateDetails?.private_conversation
            ? [...templateDetails?.comp_hidden_filter]
            : [];
        if (
          comp_hidden_filter?.length &&
          templateDetails?.template_type === "competition"
        ) {
          filters = comp_hidden_filter;
          callNotification(
            "Filters updated by excluding Private conversations",
            "info"
          );
        }

        // // to store quick filters on clear filters action
        // if (templateDetails?.quick_filter_value) {
        //   filters = [...filters, templateDetails?.quick_filter_value];
        // }

        // // to store hidden filters on clear filters action
        // if (templateDetails?.hidden_filter) {
        //   filters = [...filters, templateDetails?.hidden_filter];
        // }

        dispatch(
          setTemplateDetails(templateDetails, {
            filters: filters ? filters : [],
            dashboard_called_api_list: [],
          })
        );
      } else {
        dispatch(
          setTemplateDetails(templateDetails, {
            filters: value,
            dashboard_called_api_list: [],
          })
        );
      }
      // we are call api through getTemplateFilter, so here we stop previous api calls because here we perform global level changes
      window?.stop();
      dispatch(setTemplateFilter(templateObject));
    } else if (selectedSection?.type === "template_section") {
      let global = templateDetails?.templateFilters
        ? templateDetails?.templateFilters
        : [];

      let global_brands = templateDetails?.templateBrands
        ? templateDetails?.templateBrands
        : null;
      let global_duration = templateDetails?.templateDuration
        ? templateDetails?.templateDuration
        : null;

      let res = null;
      let newSection = null;
      let currectSection = Section?.[editPanelInfo?.section_index];
      let secLockedOnBrand =
        !widgetsClearFilter &&
        selectedSection?.is_locked &&
        currectSection?.brands?.length > 0 &&
        (currectSection?.brands?.[0]?.columns
          ? !currectSection?.brands?.[0]?.columns?.[0]?.competitor
          : !currectSection?.brands?.[0]?.competitor);
      // if dupliates widget exists and global brand is competitor then need split again
      if (secLockedOnBrand || (competitorBrandType && !widgetsClearFilter)) {
        res = checkForDuplicateWidgets([currectSection]);
        if (res?.parentExists) {
          let filterSectionData = getFilterDuplicateWidgets([currectSection]);
          if (filterSectionData !== null) {
            newSection = filterSectionData;
          }
        }
      } else {
        res = checkForDuplicateWidgets([currectSection]);
        let comBrand = global_brands?.columns?.[0]?.competitor
          ? global_brands?.columns?.[0]
          : global_brands?.[0]?.competitor
          ? global_brands?.[0]
          : global_brands?.competitor
          ? global_brands
          : null;
        if (res?.parentExists && comBrand?.competitor) {
          let filterSectionData = getFilterDuplicateWidgets([currectSection]);
          if (filterSectionData !== null) {
            let newBrandList = [];
            newBrandList.push({
              brand_id: comBrand?.name,
              brand_name: comBrand?.brand_name,
              brand_friendly_name: comBrand?.brand_friendly_name,
            });
            comBrand?.competitorList?.forEach((competitorBrand) => {
              newBrandList.push(competitorBrand);
            });
            newSection = splitSectionWidgets(
              filterSectionData,
              newBrandList,
              brands
            );
          }
        } else if (res?.duplicateExists && comBrand?.competitor) {
          let newBrandList = [];
          newBrandList.push({
            brand_id: comBrand?.name,
            brand_name: comBrand?.brand_name,
            brand_friendly_name: comBrand?.brand_friendly_name,
          });
          comBrand?.competitorList?.forEach((competitorBrand) => {
            newBrandList.push(competitorBrand);
          });
          let forParticularSection = {
            section_index: 0,
            section_id: currectSection?.id,
          };
          let ignoreSectionComFilterFor = {
            ...forParticularSection,
          };
          newSection = splitSectionWidgets(
            [currectSection],
            newBrandList,
            brands,
            null,
            ignoreSectionComFilterFor
          );
        }
      }
      if (res && (res?.duplicateExists || res?.parentExists) && newSection) {
        Section[editPanelInfo?.section_index] = newSection?.[0];
      }
      if (competitorBrandType && !widgetsClearFilter) {
        Section[editPanelInfo?.section_index].comp_brand_type =
          competitorBrandType === "Parent"
            ? false
            : competitorBrandType === "Competition"
            ? true
            : null;
      } else {
        Section[editPanelInfo?.section_index].comp_brand_type = null;
      }
      let templateObj = {
        section: Section,
        templateDetails: templateDetails,
        section_index: selectedSection?.section_index,
        authParams: authParams,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        global_brands: selectedSection?.is_locked
          ? templateBrandObj?.selectBrands
            ? templateBrandObj?.selectBrands
            : Section[selectedSection?.section_index]?.brandFilters
          : global_brands,
        filters: value
          ? value
          : Section[selectedSection?.section_index]?.onlyFilters,
        duration: widgetsClearFilter
          ? global_duration
          : selectedSection?.is_locked
          ? templateDateFilterObj?.templateObj?.durationObj
            ? templateDateFilterObj?.templateObj?.durationObj
            : Section[selectedSection?.section_index]?.dateFilters
            ? Section[selectedSection?.section_index]?.dateFilters
            : global_duration
          : global_duration,
        is_locked: widgetsClearFilter ? false : selectedSection?.is_locked,
        brandFilters: widgetsClearFilter
          ? null
          : // : templateBrandObj?.selectBrands
            // ? templateBrandObj?.selectBrands
            Section[selectedSection?.section_index]?.brandFilters,
        dateFilters:
          // templateDateFilterObj?.templateObj?.durationObj
          //   ? templateDateFilterObj?.templateObj?.durationObj
          //   :
          Section[selectedSection?.section_index]?.dateFilters,
        clear: widgetsClearFilter,
      };

      dispatch(setTemplateSectionFilter(templateObj, widgetsClearFilter));

      let obj = {
        type: "template_section",
        filters: global,
        section: Section,
        brands: templateDetails?.brands
          ? templateDetails?.brands
          : brandlogicalgroup?.length > 0
          ? brandlogicalgroup
          : brands,
        authParams: authParams,
        duration: templateDetails?.templateDuration
          ? templateDetails?.templateDuration
          : null,
        currentFilter: value ? value : [],
        graphConditionConfig: graphConditionConfig,
      };

      dispatch(setTemplateFilter(obj, templateObj));
      if (widgetsClearFilter) {
        let durationObject = {
          type: "template_section",

          dateValue: dateValue1,
          timeValue: timeValue,
        };
        let brandsObject = {
          type: "template_section",
          value: null,
          brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
          selectBrandValue: selectBrandValue,
          brandCheckedItems: brandCheckedItems,
        };
        dispatch(setSectionDateValue(durationObject));
        dispatch(setSectionBrandValue(brandsObject));

        // To clear selected profile filters of widgets on section level
        dispatch(setClearProfileFiltersSection(Section));
      }

      // dispatch(setSectionDuration(templateObj));
    } else if (selectedSection?.type === "template_widget") {
      let global = templateDetails?.templateFilters
        ? templateDetails?.templateFilters
        : [];
      let global_brands = templateDetails?.templateBrands
        ? templateDetails?.templateBrands
        : null;

      let global_duration = templateDetails?.templateDuration
        ? templateDetails?.templateDuration
        : null;

      let widget_metadata =
        selectedSection?.section_index >= 0 &&
        selectedSection?.section_index !== null
          ? Section?.[selectedSection?.section_index]?.data?.[
              selectedSection?.widget_index
            ]
          : Section?.[0]?.data?.[selectedSection?.widget_index];

      let profile_filters_list =
        selectedSection?.section_index >= 0 &&
        selectedSection?.section_index !== null
          ? Section?.[selectedSection?.section_index]?.data?.[
              selectedSection?.widget_index
            ]?.profile_filters_list
          : Section?.[0]?.data?.[selectedSection?.widget_index]
              ?.profile_filters_list;

      let section_profile_filters_list =
        selectedSection?.section_index >= 0 &&
        selectedSection?.section_index !== null
          ? Section?.[selectedSection?.section_index]?.profile_filters_list
          : Section?.[0]?.profile_filters_list;

      let res = null;
      let newSection = deepCopy(Section);
      let updatedSection = null;
      let currectSection = deepCopy(Section?.[editPanelInfo?.section_index]);
      let forParticularSection = {
        section_index: selectedSection?.section_index
          ? selectedSection?.section_index
          : 0,
        section_id: currectSection?.id,
        widget_id: selectedSection?.id,
        widget_index: selectedSection?.widget_index,
      };
      // if dupliates widget exists and global brand is competitor then need split again
      let secLockedOnBrand =
        currectSection?.is_locked &&
        currectSection?.brands &&
        currectSection?.brands?.length > 0 &&
        (currectSection?.brands?.[0]?.columns
          ? !currectSection?.brands?.[0]?.columns?.[0]?.competitor
          : !currectSection?.brands?.[0]?.competitor);
      let comBrandtypeExists =
        currectSection?.comp_brand_type === false ||
        currectSection?.comp_brand_type === true
          ? true
          : false;
      let currectWidget =
        currectSection?.data && currectSection?.data?.length > 0
          ? currectSection?.data?.[selectedSection?.widget_index]
          : currectSection?.widgets?.[selectedSection?.widget_index];
      let widgetLockedOnBrand =
        !widgetsClearFilter &&
        selectedSection?.is_locked &&
        currectWidget?.brands?.length > 0 &&
        (currectWidget?.brands?.[0]?.columns
          ? !currectWidget?.brands?.[0]?.columns?.[0]?.competitor
          : !currectWidget?.brands?.[0]?.competitor);
      let comBrand = global_brands?.columns?.[0]?.competitor
        ? global_brands?.columns?.[0]
        : global_brands?.[0]?.competitor
        ? global_brands?.[0]
        : global_brands?.competitor
        ? global_brands
        : null;
      if (
        comBrand &&
        !secLockedOnBrand &&
        !comBrandtypeExists &&
        !widgetLockedOnBrand &&
        currectWidget?.chart &&
        currectWidget?.chart?.["chart_settings"]["duplicate_for_brands"]
      ) {
        res = checkForDuplicateWidgets(newSection, forParticularSection);
        if (res?.parentExists) {
          let filterSectionData = getFilterDuplicateWidgets(
            newSection,
            forParticularSection
          );
          if (filterSectionData !== null) {
            let iOfW = filterSectionData?.[forParticularSection?.section_index]
              ?.data?.length
              ? filterSectionData?.[
                  forParticularSection?.section_index
                ]?.data?.findIndex(
                  (el) => el?.widget_id === forParticularSection?.widget_id
                )
              : filterSectionData?.[
                  forParticularSection?.section_index
                ]?.widgets?.findIndex(
                  (el) => el?.widget_id === forParticularSection?.widget_id
                );
            if (iOfW !== -1) {
              // if (
              //   filterSectionData?.[forParticularSection?.section_index]?.data
              //     ?.length
              // ) {
              //   filterSectionData[forParticularSection?.section_index].data[
              //     iOfW
              //   ] = currectWidget; // need to assign updated widget metadata
              // } else {
              //   filterSectionData[forParticularSection?.section_index].widgets[
              //     iOfW
              //   ] = currectWidget; // need to assign updated widget metadata
              // }
            }
            let newBrandList = [];
            newBrandList.push({
              brand_id: comBrand?.name,
              brand_name: comBrand?.brand_name,
              brand_friendly_name: comBrand?.brand_friendly_name,
            });
            comBrand?.competitorList?.forEach((competitorBrand) => {
              newBrandList.push(competitorBrand);
            });

            updatedSection = splitSectionWidgets(
              filterSectionData,
              newBrandList,
              brands
            );
          }
        } else if (res?.duplicateExists) {
          let newBrandList = [];
          newBrandList.push({
            brand_id: comBrand?.name,
            brand_name: comBrand?.brand_name,
            brand_friendly_name: comBrand?.brand_friendly_name,
          });
          comBrand?.competitorList?.forEach((competitorBrand) => {
            newBrandList.push(competitorBrand);
          });
          let ignoreWidgetLockFor = {
            ...forParticularSection,
          };
          updatedSection = splitSectionWidgets(
            newSection,
            newBrandList,
            brands,
            ignoreWidgetLockFor
          );
        }
      } else if (
        currectWidget?.chart &&
        currectWidget?.chart?.["chart_settings"]["duplicate_for_brands"]
      ) {
        res = checkForDuplicateWidgets(newSection, forParticularSection);
        if (res?.parentExists) {
          let filterSectionData = getFilterDuplicateWidgets(
            newSection,
            forParticularSection
          );
          if (filterSectionData !== null) {
            let iOfW = filterSectionData?.[forParticularSection?.section_index]
              ?.data?.length
              ? filterSectionData?.[
                  forParticularSection?.section_index
                ]?.data?.findIndex(
                  (el) => el?.widget_id === forParticularSection?.widget_id
                )
              : filterSectionData?.[
                  forParticularSection?.section_index
                ]?.widgets?.findIndex(
                  (el) => el?.widget_id === forParticularSection?.widget_id
                );
            if (iOfW !== -1) {
              // if (
              //   filterSectionData?.[forParticularSection?.section_index]?.data
              //     ?.length
              // ) {
              //   filterSectionData[forParticularSection?.section_index].data[
              //     iOfW
              //   ] = currectWidget; // need to assign updated widget metadata
              // } else {
              //   filterSectionData[forParticularSection?.section_index].widgets[
              //     iOfW
              //   ] = currectWidget; // need to assign updated widget metadata
              // }
            }
            updatedSection = filterSectionData;
          }
        }
      }
      let needToBeUpdateSectionAllWidgetsWithId = null;
      if (
        res &&
        (res?.duplicateExists || res?.parentExists) &&
        updatedSection
      ) {
        Section[editPanelInfo?.section_index] =
          updatedSection?.[editPanelInfo?.section_index];
        needToBeUpdateSectionAllWidgetsWithId = {
          ...forParticularSection,
        };
      }
      let templateObj = {
        section: Section,
        templateDetails: templateDetails,
        section_index: selectedSection?.section_index,
        widget_index: selectedSection?.widget_index,
        authParams: authParams,
        global_brands: selectedSection?.is_locked
          ? templateBrandObj?.selectBrands
            ? templateBrandObj?.selectBrands
            : selectedSection?.section_index
            ? Section[selectedSection?.section_index]?.data[
                selectedSection?.widget_index
              ]?.brandFilters
            : Section[0]?.data[selectedSection?.widget_index]?.brandFilters
          : global_brands,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        filters: value
          ? value
          : selectedSection?.section_index
          ? Section[selectedSection?.section_index]?.data[
              selectedSection?.widget_index
            ]?.onlyFilters
          : Section[0]?.data[selectedSection?.widget_index]?.onlyFilters,
        duration: widgetsClearFilter
          ? global_duration
          : selectedSection?.is_locked
          ? templateDateFilterObj?.templateObj?.durationObj
            ? templateDateFilterObj?.templateObj?.durationObj
            : Section[selectedSection?.section_index]?.dateFilters
            ? Section[selectedSection?.section_index]?.dateFilters
            : global_duration
          : global_duration,
        is_locked: widgetsClearFilter ? false : selectedSection?.is_locked,
        brandFilters: widgetsClearFilter
          ? null
          : // : templateBrandObj?.selectBrands
          // ? templateBrandObj?.selectBrands
          selectedSection?.section_index
          ? Section[selectedSection?.section_index]?.data[
              selectedSection?.widget_index
            ]?.brandFilters
          : Section[0]?.data[selectedSection?.widget_index]?.brandFilters,
        dateFilters:
          // templateDateFilterObj?.templateObj?.durationObj
          //   ? templateDateFilterObj?.templateObj?.durationObj
          //   :
          selectedSection?.section_index
            ? Section[selectedSection?.section_index]?.data[
                selectedSection?.widget_index
              ]?.dateFilters
            : Section[0]?.data[selectedSection?.widget_index]?.dateFilters,
        clear: widgetsClearFilter,
        span_check:
          templateDateFilterObj?.templateObj?.durationObj ||
          templateBrandObj?.selectBrands ||
          value?.length > 0
            ? true
            : false,
        filterChange: filterChange,
        profile_filters: widgetsClearFilter
          ? null
          : widget_metadata?.profile_filters_flag && dashboardProfileFilterObj
          ? dashboardProfileFilterObj
          : widget_metadata?.payload?.profile_filters,
        profile_filters_list: widgetsClearFilter
          ? section_profile_filters_list
            ? section_profile_filters_list
            : profileFilterList
          : profile_filters_list
          ? profile_filters_list
          : profileFilterList,
        profile_filters_flag: widget_metadata?.profile_filters_flag,
      };

      dispatch(
        setTemplateWidgetFilter(
          templateObj,
          widgetsClearFilter,
          null,
          needToBeUpdateSectionAllWidgetsWithId
        )
      );

      let obj = {
        type: "template_widget",
        filters: global,
        section: templateBrandObj?.section
          ? templateBrandObj?.section
          : Section,
        brands: templateDetails?.brands
          ? templateDetails?.brands
          : brandlogicalgroup?.length > 0
          ? brandlogicalgroup
          : brands,
        authParams: authParams,
        duration: templateDetails?.templateDuration
          ? templateDetails?.templateDuration
          : null,
        currentFilter: value ? value : [],
        filterChange: filterChange,
        graphConditionConfig: graphConditionConfig,
        profile_filters: widgetsClearFilter
          ? null
          : widget_metadata?.profile_filters_flag && dashboardProfileFilterObj
          ? dashboardProfileFilterObj
          : widget_metadata?.payload?.profile_filters,
        profile_filters_list: profile_filters_list
          ? profile_filters_list
          : profileFilterList,
        profile_filters_flag: widget_metadata?.profile_filters_flag,
      };

      dispatch(setTemplateFilter(obj, templateObj));
      if (widgetsClearFilter) {
        let durationObject = {
          type: "template_widget",

          dateValue: dateValue1,
          timeValue: timeValue,
        };
        let brandsObject = {
          type: "template_widget",
          value: null,
          brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
          selectBrandValue: selectBrandValue,
          brandCheckedItems: brandCheckedItems,
        };
        dispatch(setWidgetDateValue(durationObject));
        dispatch(setWidgetBrandValue(brandsObject));
      }

      if (widgetsClearFilter) {
        let updateselectValue = { ...selectProfileFilterValue };
        updateselectValue[type].data = {
          columns: [],
          attribute: "SocialMediaProfiles",
          type: "varchar",
        };
        dispatch(setSelectProfileFilterValue(updateselectValue));

        let updatecheckedValue = { ...profileFilterCheckedItems };
        updatecheckedValue[type].data = {};
        dispatch(setProfileFilterCheckedItems(updatecheckedValue));
      }
    }

    let index = getPaneIndex(panes, activeKeys);

    if (
      !selectedSection?.type &&
      !graph_page &&
      type !== "widgetMaker" &&
      type !== "share_modal" &&
      type !== "command_center_global" &&
      type !== "deep_dive_global" &&
      type?.split("_")[0] !== "kpi" &&
      type?.split("_")[0] !== "y"
    ) {
      let comp_hidden_filter =
        panes?.[index]?.comp_hidden_filter &&
        !panes[index]?.private_conversation
          ? [...panes?.[index]?.comp_hidden_filter]
          : [];
      dispatch(setDashboardFilters(value, index, panes));
      let finalFilter = [...value];

      let uniqueFilters = getUniqueFilters(finalFilter);

      let paneObj = {
        panes: panes,
        activeKey: activeKeys,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        singleBrands: brands,
        authParams: authParams,
        index: index,
        competitorBrands: competitorBrands,
        graphConditionConfig: graphConditionConfig,
        is_modified_date:
          panes?.[index]?.template_id === "000-000-002" ||
          panes?.[index]?.template_id === "000-000-004"
            ? panes?.[index]?.is_modified_date
              ? panes?.[index]?.is_modified_date
              : false
            : null,
      };
      if (filterClear || widgetsClearFilter) {
        uniqueFilters = [];
        if (
          panes?.[index]?.private_conversation &&
          panes?.[index]?.comp_hidden_filter?.length &&
          panes?.[index]?.template_type === "competition"
        ) {
          let filters = getPrivateConversationFilters(
            panes?.[index]?.comp_hidden_filter,
            panes?.[index]?.filters
          );
          dispatch(setPrivateConversation(false, panes, index, filters));
          callNotification(
            "Filters updated by excluding Private conversations",
            "info "
          );
        } else if (
          comp_hidden_filter?.length &&
          panes?.[index]?.template_type === "competition"
        ) {
          uniqueFilters = comp_hidden_filter;
          callNotification(
            "Filters updated by excluding Private conversations",
            "info "
          );
        }
        if (
          selectedPill !== undefined &&
          selectedPill[0] &&
          Object.keys(selectedPill?.[0])?.length > 0
        ) {
          if (
            panes?.[index]?.template_type === "competition" &&
            !panes[index].private_conversation
          ) {
            // uniqueFilters = [
            //   ...panes[index]?.comp_hidden_filter,
            //   ...selectedPill[0]?.saved_filters,
            // ];
            uniqueFilters = mergeArrays(
              deepCopy([...panes[index]?.comp_hidden_filter]),
              deepCopy([...selectedPill[0]?.saved_filters])
            );
            if (panes[index]?.saved_filters?.length) {
              let mergedFilters = getPrivateConversationFilters(
                panes?.[index]?.comp_hidden_filter,
                panes?.[index]?.saved_filters,
                panes?.[index]?.saved_filters
              );
              uniqueFilters = [...uniqueFilters, ...mergedFilters];
            }
          } else if (panes[index]?.hidden_filter?.attribute) {
            let hiddenAttribute =
              panes?.[index]?.hidden_filter?.attribute?.toLowerCase();
            let saved_filters = panes?.[index]?.saved_filters?.length
              ? panes?.[index]?.saved_filters
              : [];
            uniqueFilters = [...selectedPill[0].saved_filters];
            if (saved_filters?.length) {
              uniqueFilters = mergeArrays(
                deepCopy(uniqueFilters),
                deepCopy(saved_filters)
              );
            }
            if (uniqueFilters.length) {
              uniqueFilters = uniqueFilters.filter(
                (item) => item?.attribute?.toLowerCase() !== hiddenAttribute
              );
            }
          } else {
            uniqueFilters = [...selectedPill[0].saved_filters];
            if (panes[index]?.saved_filters?.length) {
              let mergedFilters = getPrivateConversationFilters(
                panes?.[index]?.comp_hidden_filter,
                panes?.[index]?.saved_filters,
                panes?.[index]?.saved_filters
              );
              uniqueFilters = [...uniqueFilters, ...mergedFilters];
            }
          }
        } else if (panes[index]?.saved_filters?.length) {
          let mergedFilters = getPrivateConversationFilters(
            panes?.[index]?.comp_hidden_filter,
            panes?.[index]?.saved_filters,
            panes?.[index]?.saved_filters
          );
          uniqueFilters = [...mergedFilters];
        }
        panes[index].filters = uniqueFilters;
        dispatch(setGlobalFilter(uniqueFilters, index, panes, paneObj));
      } else {
        dispatch(
          setGlobalFilter(
            widgetsClearFilter ? [] : uniqueFilters,
            index,
            panes,
            paneObj
          )
        );
        panes[index].filters = widgetsClearFilter ? [] : uniqueFilters;
      }

      panes[index].predefined &&
        uniqueFilters?.length === 0 &&
        panes[index].predefined &&
        panes[index]?.template_type === "ticket" &&
        panes[index].template_id === "000-000-002" &&
        panes[index].template_id === "000-000-003" &&
        uniqueFilters.push(...panes[index].defaultFilters);

      dispatch(
        setTemplateDetails(templateDetails, {
          filters: widgetsClearFilter ? [] : uniqueFilters,
        })
      );

      dispatch(setClearGraphData(paneObj?.index, paneObj?.panes, paneObj));

      //dispatch(setOptionHighChart(null));

      // to set global selected widget in redux state to scroll that widget
      dispatch(setGlobalSelectedWidgetId(visitedWidgetId));
    } else if (selectedSection?.type === "sectionFilter") {
      let section = panes[index]?.sections[selectedSection?.section_index];
      let filters, section_id;
      let paneObj = {
        panes: panes,
        activeKey: activeKeys,
        brands: brands,
      };

      if (selectedSection?.is_locked) {
        let brandFilter = dashboardBrandObj?.brandFilters
          ? dashboardBrandObj?.brandFilters
          : // : panes[index]?.sections[selectedSection?.section_index]?.brandFilters
            // ? panes[index]?.sections[selectedSection?.section_index]?.brandFilters
            null;
        section.brandFilters = widgetsClearFilter ? [] : brandFilter;
        section.is_locked = true;
        section_id =
          panes[index]?.sections[selectedSection?.section_index]?.section_id;
        filters = panes[index]?.sections[selectedSection?.section_index]
          ?.filters
          ? panes[index]?.sections[selectedSection?.section_index]?.filters
          : [];

        let dateFilter = dashboardDateFilterObj?.dateFilters
          ? [...dashboardDateFilterObj?.dateFilters]
          : // : panes[index]?.sections[selectedSection?.section_index]?.dateFilters
            // ? panes[index]?.sections[selectedSection?.section_index]?.dateFilters
            [];
        let finalFilter =
          value?.length > 0
            ? [...value]
            : filterChange && value?.length === 0
            ? []
            : [...filters];

        let uniqueFilters = getUniqueFilters(finalFilter);

        // Reset widget filters Start
        let widget_profile_reset;

        let profile_filter_widget;
        let section_metadata = panes?.[index]?.sections
          ? panes?.[index]?.sections?.[selectedSection?.section_index]
          : panes?.[index]?.section?.[0];

        section_metadata?.widgets?.map((d) => {
          if (d?.profile_filters_flag) {
            profile_filter_widget = true;
          }
        });

        if (profile_filter_widget) {
          let widget_id = [];
          let widget_uuid = [];

          section_metadata?.widgets?.map((widget) => {
            if (
              !widget?.is_locked ||
              (widget?.is_locked && !widget?.brand_ids && !widget?.brand_groups)
            ) {
              if (widget?.widget_uuid) {
                widget_uuid = [...widget_uuid, widget?.widget_uuid];
              } else {
                widget_id = [...widget_id, widget?.widget_id];
              }
            }
          });

          widget_profile_reset = {
            widget_id_list: widget_id ? widget_id : [],
            widget_uuid_list: widget_uuid ? widget_uuid : [],
          };
        }

        // Reset widget filters end

        let paneObj = {
          panes: panes,
          activeKey: activeKeys,
          brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
          brandFilter: widgetsClearFilter ? [] : brandFilter,
          template_id: panes[index]?.template_id,
          isBrandModified: brandFilter ? true : false,
          singleBrands: brands,
          index: index,
          widgetMaker: panes[index]?.sections
            ? panes[index]?.sections[selectedSection?.section_index]?.widgets[
                selectedSection?.widget_index
              ]?.chart
              ? "widget-maker"
              : "x-y"
            : panes[index]?.section &&
              panes[index]?.section[0]?.widgets[selectedSection?.widget_index]
                ?.chart
            ? "widget-maker"
            : "x-y",
          quickFilter:
            panes[index]?.profiles && panes[index]?.profiles[0]?.AccountID
              ? panes[index]?.profiles[0]?.AccountID
              : [],
          graphConditionConfig: graphConditionConfig,
          temporary_words: temporary_words,
          widget_profile_reset: widgetsClearFilter
            ? widget_profile_reset
            : dashboardBrandObj?.brand_selected && widget_profile_reset
            ? widget_profile_reset
            : null,
        };

        let finalFilters = widgetsClearFilter
          ? []
          : [...dateFilter, ...uniqueFilters];

        authParams &&
          dispatch(
            setUpdateFiltersInSection(
              authParams,
              section_id,
              finalFilters,
              paneObj,
              selectedSection?.is_locked,
              widgetsClearFilter,
              clearBrandAndDuration
            )
          );
      } else if (!selectedSection?.is_locked) {
        let brandFilter = dashboardBrandObj?.brandFilters
          ? dashboardBrandObj?.brandFilters
          : // : panes[index]?.sections[selectedSection?.section_index]?.brandFilters
            // ? panes[index]?.sections[selectedSection?.section_index]?.brandFilters
            null;
        section.is_locked = false;
        section_id =
          panes[index]?.sections[selectedSection?.section_index]?.section_id;
        filters = panes[index]?.sections[selectedSection?.section_index]
          ?.filters
          ? panes[index]?.sections[selectedSection?.section_index]?.filters
          : [];

        let dateFilter = dashboardDateFilterObj?.dateFilters
          ? [...dashboardDateFilterObj?.dateFilters]
          : // : panes[index]?.sections[selectedSection?.section_index]?.dateFilters
            // ? panes[index]?.sections[selectedSection?.section_index]?.dateFilters
            [];

        let globalFilter = panes[index]?.filters ? panes[index]?.filters : [];

        let finalFilter =
          value?.length > 0
            ? [...value]
            : filterChange && value?.length === 0
            ? []
            : [...filters];
        let uniqueFilters = getUniqueFilters(finalFilter);

        // Reset widget filters Start
        let widget_profile_reset;

        let profile_filter_widget;
        let section_metadata = panes?.[index]?.sections
          ? panes?.[index]?.sections?.[selectedSection?.section_index]
          : panes?.[index]?.section?.[0];

        section_metadata?.widgets?.map((d) => {
          if (d?.profile_filters_flag) {
            profile_filter_widget = true;
          }
        });

        if (profile_filter_widget) {
          let widget_id = [];
          let widget_uuid = [];

          section_metadata?.widgets?.map((widget) => {
            if (
              !widget?.is_locked ||
              (widget?.is_locked && !widget?.brand_ids && !widget?.brand_groups)
            ) {
              if (widget?.widget_uuid) {
                widget_uuid = [...widget_uuid, widget?.widget_uuid];
              } else {
                widget_id = [...widget_id, widget?.widget_id];
              }
            }
          });

          widget_profile_reset = {
            widget_id_list: widget_id ? widget_id : [],
            widget_uuid_list: widget_uuid ? widget_uuid : [],
          };
        }

        // Reset widget filters end

        let paneObj = {
          panes: panes,
          activeKey: activeKeys,
          brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
          authParams: authParams,
          index: index,
          brandFilter: widgetsClearFilter ? [] : brandFilter,
          template_id: panes[index]?.template_id,
          isBrandModified: brandFilter ? true : false,
          singleBrands: brands,
          widgetMaker: panes[index]?.sections
            ? panes[index]?.sections[selectedSection?.section_index]?.widgets[
                selectedSection?.widget_index
              ]?.chart
              ? "widget-maker"
              : "x-y"
            : panes[index]?.section &&
              panes[index]?.section[0]?.widgets[selectedSection?.widget_index]
                ?.chart
            ? "widget-maker"
            : "x-y",
          graphConditionConfig: graphConditionConfig,
          temporary_words: temporary_words,
          widget_profile_reset: widgetsClearFilter
            ? widget_profile_reset
            : dashboardBrandObj?.brand_selected && widget_profile_reset
            ? widget_profile_reset
            : null,
        };

        let finalFilters = widgetsClearFilter
          ? []
          : [...dateFilter, ...uniqueFilters];
        //dispatch(setGlobalFilter(filters, index, panes, paneObj));

        authParams &&
          dispatch(
            setUpdateFiltersInSection(
              authParams,
              section_id,
              finalFilters,
              paneObj,
              selectedSection?.is_locked,
              widgetsClearFilter,
              clearBrandAndDuration
            )
          );
      }
    } else if (selectedSection?.type === "widgetFilter") {
      let widget = panes[index]?.sections
        ? panes[index]?.sections[selectedSection?.section_index]?.widgets[
            selectedSection?.widget_index
          ]
        : panes[index]?.section &&
          panes[index]?.section[0]?.widgets[selectedSection?.widget_index];
      //to clear id from opdata

      if (selectedSection?.is_locked) {
        if (widget) widget.is_locked = true;

        let section_id = panes[index]?.sections
          ? panes[index]?.sections[selectedSection?.section_index]?.section_id
          : panes[index]?.section && panes[index]?.section[0]?.section_id;
        if (panes[index].sections) {
          panes[index].sections[selectedSection?.section_index].widgets[
            selectedSection?.widget_index
          ] = widget;
        } else if (panes[index].section) {
          //only widgets
          panes[index].section[0].widgets[selectedSection?.widget_index] =
            widget;
        }

        let brandFilter = widgetsClearFilter
          ? []
          : dashboardBrandObj?.brandFilters
          ? dashboardBrandObj?.brandFilters
          : null;
        // : panes[index]?.section
        // ? panes[index]?.section &&
        //   panes[index]?.section[0]?.widgets[selectedSection?.widget_index]
        //     ?.brandFilters &&
        //   panes[index]?.section &&
        //   panes[index]?.section[0]?.widgets[selectedSection?.widget_index]
        //     ?.brandFilters
        // : panes[index]?.sections[selectedSection?.section_index]?.widgets[
        //     selectedSection?.widget_index
        //   ]?.brandFilters;
        let widget_id = panes[index]?.sections
          ? panes[index]?.sections[selectedSection?.section_index]?.widgets[
              selectedSection?.widget_index
            ].widget_id
          : panes[index]?.section &&
            panes[index]?.section[0]?.widgets[selectedSection?.widget_index]
              .widget_id;
        let filters = panes[index]?.sections
          ? panes[index]?.sections[selectedSection?.section_index]?.widgets[
              selectedSection?.widget_index
            ]?.filters
            ? panes[index]?.sections[selectedSection?.section_index]?.widgets[
                selectedSection?.widget_index
              ]?.filters
            : []
          : panes[index]?.section &&
            panes[index]?.section[0]?.widgets[selectedSection?.widget_index]
              ?.filters
          ? panes[index]?.section &&
            panes[index]?.section[0]?.widgets[selectedSection?.widget_index]
              .filters
          : [];
        let dateFilter = widgetsClearFilter
          ? []
          : dashboardDateFilterObj?.dateFilters
          ? [...dashboardDateFilterObj?.dateFilters]
          : [];
        // : panes[index].section
        // ? panes[index]?.section &&
        //   panes[index].section[0].widgets[selectedSection?.widget_index]
        //     ?.dateFilters
        //   ? panes[index]?.section &&
        //     panes[index].section[0].widgets[selectedSection?.widget_index]
        //       ?.dateFilters
        //   : []
        // : panes[index].sections[selectedSection?.section_index].widgets[
        //     selectedSection?.widget_index
        //   ]?.dateFilters
        // ? panes[index].sections[selectedSection?.section_index].widgets[
        //     selectedSection?.widget_index
        //   ]?.dateFilters
        let finalFilter =
          value?.length > 0
            ? [...value]
            : filterChange && value?.length === 0
            ? []
            : [...filters];
        let uniqueFilters = getUniqueFilters(finalFilter);

        //to clear graphData
        let updatePanes = [...panes];

        //  To add by default filters
        let profile_filters_list =
          selectedSection?.section_index >= 0 &&
          selectedSection?.section_index !== null
            ? panes?.[index]?.sections?.[selectedSection?.section_index]
                ?.widgets?.[selectedSection?.widget_index]?.profile_filters_list
            : panes?.[index]?.section?.[0]?.widgets?.[
                selectedSection?.widget_index
              ]?.profile_filters_list;

        let widget_metadata = panes[index]?.sections
          ? panes[index]?.sections[selectedSection?.section_index]?.widgets[
              selectedSection?.widget_index
            ]
          : panes[index]?.section &&
            panes[index]?.section[0]?.widgets[selectedSection?.widget_index];

        let defaultProfileFilters;
        if (profile_filters_list) {
          defaultProfileFilters = {
            columns: [
              {
                name: profile_filters_list?.[0]?.id,
                type: "include",
                display_name: profile_filters_list?.[0]?.name,
                profile_channel: profile_filters_list?.[0]?.channel,
                brand_id: profile_filters_list?.[0]?.brand_id,
              },
            ],
            attribute: "SocialMediaProfiles",
            type: "varchar",
          };
        }

        let updatedChart = widget_metadata?.chart;
        if (enteredPlannedValue?.[type]?.data?.value) {
          updatedChart.chart_settings.planned_val =
            enteredPlannedValue?.[type]?.data?.value;
        }
        let paneObj = {
          competitorBrands: competitorBrands,
          panes: updatePanes,
          activeKey: activeKeys,
          brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
          section_id: section_id
            ? section_id
            : dashboardDateFilterObj?.section_id,
          widget_id: widget_id ? widget_id : dashboardDateFilterObj?.widget_id,
          widget_index: selectedSection?.widget_index,
          brandFilter: widgetsClearFilter ? [] : brandFilter,
          template_id: panes[index]?.template_id,
          singleBrands: brands,
          isBrandModified: brandFilter ? true : false,
          widgetMaker: panes[index]?.sections
            ? panes[index]?.sections[selectedSection?.section_index]?.widgets[
                selectedSection?.widget_index
              ]?.chart
              ? "widget-maker"
              : "x-y"
            : panes[index]?.section &&
              panes[index]?.section[0]?.widgets[selectedSection?.widget_index]
                ?.chart
            ? "widget-maker"
            : "x-y",
          onlyWidgets: panes[index]?.section ? true : false,
          graphConditionConfig: graphConditionConfig,
          temporary_words: temporary_words,
          widget_predefined: panes[index]?.sections
            ? panes[index]?.sections[selectedSection?.section_index]?.widgets[
                selectedSection?.widget_index
              ]?.type
            : panes[index]?.section[0]?.widgets[selectedSection?.widget_index]
                ?.type,
          profile_filters: widgetsClearFilter
            ? null
            : dashboardProfileFilterObj?.columns?.[0]?.brand_id
            ? dashboardProfileFilterObj
            : widget_metadata?.profile_filters
            ? widget_metadata?.profile_filters
            : defaultProfileFilters?.columns?.[0]?.brand_id
            ? defaultProfileFilters
            : null,
          profile_filters_list: profile_filters_list
            ? profile_filters_list
            : profileFilterList,
          profile_filters_flag: widget_metadata?.profile_filters_flag,
          widget_uuid: widget_metadata?.widget_uuid,
          chart: updatedChart,
          note: pdfEditorObj?.editorValue || "",
          updated_metadata: widget_metadata ? widget_metadata : null,
        };

        uniqueFilters = getUpdatedPredefinedFilter(filters, uniqueFilters);
        let finalFilters = widgetsClearFilter
          ? uniqueFilters?.findIndex((el) => el?.predefined_filters) !== -1
            ? uniqueFilters?.filter((el) => el?.predefined_filters)
            : []
          : [...dateFilter, ...uniqueFilters];
        //to clear widget graphdata data
        if (panes[index].sections) {
          panes[index].sections[selectedSection.section_index].widgets[
            selectedSection?.widget_index
          ].graphData = null;
          panes[index].sections[selectedSection.section_index].widgets[
            selectedSection?.widget_index
          ].persist_graphdata = null;
          panes[index].sections[selectedSection.section_index].widgets[
            selectedSection?.widget_index
          ].deep_dive_on = null;
        } else {
          panes[index].section[0].widgets[
            selectedSection?.widget_index
          ].graphData = null;
          panes[index].section[0].widgets[
            selectedSection?.widget_index
          ].persist_graphdata = null;
          panes[index].section[0].widgets[
            selectedSection?.widget_index
          ].deep_dive_on = null;
        }

        // To clear checked profile states
        if (widgetsClearFilter) {
          let updateselectValue = { ...selectProfileFilterValue };
          updateselectValue[type].data = {
            columns: [],
            attribute: "SocialMediaProfiles",
            type: "varchar",
          };
          dispatch(setSelectProfileFilterValue(updateselectValue));

          let updatecheckedValue = { ...profileFilterCheckedItems };
          updatecheckedValue[type].data = {};
          dispatch(setProfileFilterCheckedItems(updatecheckedValue));
        }

        // Section Case / Edit widget in dashboard case
        if (widget_metadata?.is_widget_edited && !noteEdited) {
          if (widgetsClearFilter) {
            if (
              selectedSection?.section_index !== null &&
              selectedSection?.section_index >= 0
            ) {
              updatePanes[index].sections[
                selectedSection?.section_index
              ].widgets[selectedSection?.widget_index].graphData = null;

              updatePanes[index].sections[
                selectedSection?.section_index
              ].widgets[selectedSection?.widget_index].persist_graphdata = null;

              updatePanes[index].sections[
                selectedSection?.section_index
              ].widgets[selectedSection?.widget_index].deep_dive_on = null;

              updatePanes[index].sections[
                selectedSection?.section_index
              ].widgets[selectedSection?.widget_index].filters = finalFilters;

              // Brands
              updatePanes[index].sections[
                selectedSection?.section_index
              ].widgets[selectedSection?.widget_index].brand_ids = null;
              updatePanes[index].sections[
                selectedSection?.section_index
              ].widgets[selectedSection?.widget_index].brand_groups = null;

              // Duration
              updatePanes[index].sections[
                selectedSection?.section_index
              ].widgets[selectedSection?.widget_index].start_date = null;
              updatePanes[index].sections[
                selectedSection?.section_index
              ].widgets[selectedSection?.widget_index].end_date = null;

              // console.log("updatePanes", updatePanes);
              dispatch({ type: "SET_WIDGET_GRAPH_DATA", panes: updatePanes });
            } else {
              updatePanes[index].section[0].widgets[
                selectedSection?.widget_index
              ].graphData = null;

              // clear persist_graphdata
              updatePanes[index].section[0].widgets[
                selectedSection?.widget_index
              ].persist_graphdata = null;

              // clear deep_dive_on
              updatePanes[index].section[0].widgets[
                selectedSection?.widget_index
              ].deep_dive_on = null;

              // clear filters
              updatePanes[index].section[0].widgets[
                selectedSection?.widget_index
              ].filters = finalFilters;

              // Brands
              updatePanes[index].section[0].widgets[
                selectedSection?.widget_index
              ].brand_ids = null;
              updatePanes[index].section[0].widgets[
                selectedSection?.widget_index
              ].brand_groups = null;

              // Duration
              updatePanes[index].section[0].widgets[
                selectedSection?.widget_index
              ].start_date = null;
              updatePanes[index].section[0].widgets[
                selectedSection?.widget_index
              ].end_date = null;

              // console.log("updatePanes", updatePanes);
              dispatch({ type: "SET_WIDGET_GRAPH_DATA", panes: updatePanes });
            }
          } else {
            if (
              selectedSection?.section_index !== null &&
              selectedSection?.section_index >= 0
            ) {
              // To update filters
              updatePanes[index].sections[
                selectedSection?.section_index
              ].widgets[selectedSection?.widget_index].filters = finalFilters;

              // Brand logic
              let single_brands = [];
              let brandsGroupName = [];
              if (brandFilter) {
                brandFilter?.length > 0 &&
                  brandFilter[0]?.columns?.forEach((el) => {
                    if (el?.group) {
                      brandsGroupName.push({
                        brand_group_name: el?.brand_group_name,
                      });
                    }
                  });
              }

              if (brandFilter) {
                brandFilter?.length > 0 &&
                  brandFilter[0]?.columns?.forEach((el) => {
                    if (!el?.group) {
                      single_brands.push({
                        brand_id: el?.brand_id ? el?.brand_id : el?.name,
                        brand_name: el?.brand_name
                          ? el?.brand_name
                          : el?.brand_friendly_name,
                      });
                    }
                  });
              }

              // Update Brands
              updatePanes[index].sections[
                selectedSection?.section_index
              ].widgets[selectedSection?.widget_index].brand_ids =
                single_brands && single_brands[0]?.brand_id
                  ? single_brands
                  : null;
              updatePanes[index].sections[
                selectedSection?.section_index
              ].widgets[selectedSection?.widget_index].brand_groups =
                brandsGroupName?.length ? brandsGroupName : null;

              // Update Duration
              updatePanes[index].sections[
                selectedSection?.section_index
              ].widgets[selectedSection?.widget_index].start_date =
                finalFilters && finalFilters[0]?.attribute === "CreatedDate"
                  ? finalFilters[0]?.columns?.from
                  : null;
              updatePanes[index].sections[
                selectedSection?.section_index
              ].widgets[selectedSection?.widget_index].end_date =
                finalFilters && finalFilters[0]?.attribute === "CreatedDate"
                  ? finalFilters[0]?.columns?.to
                  : null;
            } else {
              // To update filters
              updatePanes[index].section[0].widgets[
                selectedSection?.widget_index
              ].filters = finalFilters;

              // Brand logic
              let single_brands = [];
              let brandsGroupName = [];
              if (brandFilter) {
                brandFilter?.length > 0 &&
                  brandFilter[0]?.columns?.forEach((el) => {
                    if (el?.group) {
                      brandsGroupName.push({
                        brand_group_name: el?.brand_group_name,
                      });
                    }
                  });
              }

              if (brandFilter) {
                brandFilter?.length > 0 &&
                  brandFilter[0]?.columns?.forEach((el) => {
                    if (!el?.group) {
                      single_brands.push({
                        brand_id: el?.brand_id ? el?.brand_id : el?.name,
                        brand_name: el?.brand_name
                          ? el?.brand_name
                          : el?.brand_friendly_name,
                      });
                    }
                  });
              }

              // Update Brands
              updatePanes[index].section[0].widgets[
                selectedSection?.widget_index
              ].brand_ids =
                single_brands && single_brands[0]?.brand_id
                  ? single_brands
                  : null;
              updatePanes[index].section[0].widgets[
                selectedSection?.widget_index
              ].brand_groups = brandsGroupName?.length ? brandsGroupName : null;

              // Update Duration
              updatePanes[index].section[0].widgets[
                selectedSection?.widget_index
              ].start_date =
                finalFilters && finalFilters[0]?.attribute === "CreatedDate"
                  ? finalFilters[0]?.columns?.from
                  : null;
              updatePanes[index].section[0].widgets[
                selectedSection?.widget_index
              ].end_date =
                finalFilters && finalFilters[0]?.attribute === "CreatedDate"
                  ? finalFilters[0]?.columns?.to
                  : null;
            }
          }
        } else {
          authParams &&
            dispatch(
              setUpdateFiltersInWidget(
                authParams,
                widget?.childId ? widget?.childId : widget_id,
                finalFilters,
                paneObj,
                selectedSection?.is_locked,
                widgetsClearFilter,
                clearBrandAndDuration
              )
            );
        }
      } else if (!selectedSection?.is_locked) {
        let brandFilter = widgetsClearFilter
          ? []
          : dashboardBrandObj?.brandFilters
          ? dashboardBrandObj?.brandFilters
          : null;
        // : panes[index].section
        // ? panes[index]?.section &&
        //   panes[index].section[0].widgets[selectedSection?.widget_index]
        //     ?.brandFilters &&
        //   panes[index]?.section &&
        //   panes[index].section[0].widgets[selectedSection?.widget_index]
        //     ?.brandFilters
        // : panes[index].sections[selectedSection?.section_index].widgets[
        //     selectedSection?.widget_index
        //   ]?.brandFilters;
        let section_id = panes[index]?.sections
          ? panes[index]?.sections[selectedSection?.section_index]?.section_id
          : panes[index]?.section && panes[index]?.section[0]?.section_id;
        let widgetFilter = panes[index]?.sections
          ? panes[index]?.sections[selectedSection?.section_index]?.widgets[
              selectedSection?.widget_index
            ].filters
            ? panes[index]?.sections[selectedSection?.section_index]?.widgets[
                selectedSection?.widget_index
              ].filters
            : []
          : panes[index]?.section &&
            panes[index]?.section[0]?.widgets[selectedSection?.widget_index]
              .filters
          ? panes[index]?.section &&
            panes[index]?.section[0]?.widgets[selectedSection?.widget_index]
              .filters
          : [];

        let widget_id = panes[index]?.sections
          ? panes[index]?.sections[selectedSection?.section_index]?.widgets[
              selectedSection?.widget_index
            ].widget_id
          : panes[index]?.section &&
            panes[index]?.section[0]?.widgets[selectedSection?.widget_index]
              .widget_id;

        let dateFilter = widgetsClearFilter
          ? []
          : dashboardDateFilterObj?.dateFilters
          ? [...dashboardDateFilterObj?.dateFilters]
          : panes[index].section
          ? panes[index]?.section &&
            panes[index].section[0].widgets[selectedSection?.widget_index]
              ?.dateFilters
            ? panes[index]?.section &&
              panes[index].section[0].widgets[selectedSection?.widget_index]
                ?.dateFilters
            : []
          : panes[index].sections[selectedSection?.section_index].widgets[
              selectedSection?.widget_index
            ]?.dateFilters
          ? panes[index].sections[selectedSection?.section_index].widgets[
              selectedSection?.widget_index
            ]?.dateFilters
          : [];

        let sectionFilters = panes[index]?.sections?.[
          selectedSection?.section_index
        ]?.filters
          ? panes[index]?.sections[selectedSection?.section_index]?.filters
          : [];
        if (widget) widget.is_locked = false;

        let finalFilter =
          value?.length > 0
            ? [...value]
            : filterChange && value?.length === 0
            ? []
            : [...widgetFilter];

        let uniqueFilters = getUniqueFilters(finalFilter);

        // To clear checked profile states
        if (widgetsClearFilter) {
          let updateselectValue = { ...selectProfileFilterValue };
          updateselectValue[type].data = {
            columns: [],
            attribute: "SocialMediaProfiles",
            type: "varchar",
          };
          dispatch(setSelectProfileFilterValue(updateselectValue));

          let updatecheckedValue = { ...profileFilterCheckedItems };
          updatecheckedValue[type].data = {};
          dispatch(setProfileFilterCheckedItems(updatecheckedValue));
        }

        //to clear graphData
        let updatePanes = [...panes];

        let widget_metadata = panes[index]?.sections
          ? panes[index]?.sections[selectedSection?.section_index]?.widgets[
              selectedSection?.widget_index
            ]
          : panes[index]?.section &&
            panes[index]?.section[0]?.widgets[selectedSection?.widget_index];

        //  To add by default filters
        let profile_filters_list =
          selectedSection?.section_index >= 0 &&
          selectedSection?.section_index !== null
            ? panes?.[index]?.sections?.[selectedSection?.section_index]
                ?.widgets?.[selectedSection?.widget_index]?.profile_filters_list
            : panes?.[index]?.section?.[0]?.widgets?.[
                selectedSection?.widget_index
              ]?.profile_filters_list;

        let defaultProfileFilters;
        if (profile_filters_list) {
          defaultProfileFilters = {
            columns: [
              {
                name: profile_filters_list?.[0]?.id,
                type: "include",
                display_name: profile_filters_list?.[0]?.name,
                profile_channel: profile_filters_list?.[0]?.channel,
                brand_id: profile_filters_list?.[0]?.brand_id,
              },
            ],
            attribute: "SocialMediaProfiles",
            type: "varchar",
          };
        }

        let updatedChart = widget_metadata?.chart;
        if (enteredPlannedValue?.[type]?.data?.value) {
          updatedChart.chart_settings.planned_val =
            enteredPlannedValue?.[type]?.data?.value;
        }
        let paneObj = {
          competitorBrands: competitorBrands,
          panes: updatePanes,
          sectionFilters: sectionFilters,
          section_index: selectedSection?.section_index,
          activeKey: activeKeys,
          brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
          authParams: authParams,
          section_id: section_id
            ? section_id
            : dashboardDateFilterObj?.section_id,
          widget_id: widget_id ? widget_id : dashboardDateFilterObj?.widget_id,
          widget_index: selectedSection?.widget_index,
          index: index,
          brandFilter: widgetsClearFilter ? [] : brandFilter,
          template_id: panes[index]?.template_id,
          singleBrands: brands,
          isBrandModified: brandFilter ? true : false,
          widgetMaker: panes[index]?.sections
            ? panes[index]?.sections[selectedSection?.section_index]?.widgets[
                selectedSection?.widget_index
              ]?.chart
              ? "widget-maker"
              : "x-y"
            : panes[index]?.section &&
              panes[index]?.section[0]?.widgets[selectedSection?.widget_index]
                ?.chart
            ? "widget-maker"
            : "x-y",
          onlyWidgets: panes[index]?.section ? true : false,
          graphConditionConfig: graphConditionConfig,
          temporary_words: temporary_words,
          widget_predefined: panes[index]?.sections
            ? panes[index]?.sections[selectedSection?.section_index]?.widgets[
                selectedSection?.widget_index
              ]?.type
            : panes[index]?.section[0]?.widgets[selectedSection?.widget_index]
                ?.type,
          profile_filters: widgetsClearFilter
            ? null
            : dashboardProfileFilterObj?.columns?.[0]?.brand_id
            ? dashboardProfileFilterObj
            : widget_metadata?.profile_filters
            ? widget_metadata?.profile_filters
            : defaultProfileFilters?.columns?.[0]?.brand_id
            ? defaultProfileFilters
            : null,
          profile_filters_list: profile_filters_list
            ? profile_filters_list
            : profileFilterList,
          profile_filters_flag: widget_metadata?.profile_filters_flag,
          widget_uuid: widget_metadata?.widget_uuid,
          chart: updatedChart,
          note: pdfEditorObj?.editorValue || "",
          updated_metadata: widget_metadata ? widget_metadata : null,
        };

        uniqueFilters = getUpdatedPredefinedFilter(widgetFilter, uniqueFilters);
        let finalFilters = widgetsClearFilter
          ? uniqueFilters?.findIndex((el) => el?.predefined_filters) !== -1
            ? uniqueFilters?.filter((el) => el?.predefined_filters)
            : []
          : [...dateFilter, ...uniqueFilters];
        //to clear widget graphdata data
        if (panes[index].sections) {
          panes[index].sections[selectedSection.section_index].widgets[
            selectedSection?.widget_index
          ].graphData = null;

          panes[index].sections[selectedSection.section_index].widgets[
            selectedSection?.widget_index
          ].persist_graphdata = null;

          panes[index].sections[selectedSection.section_index].widgets[
            selectedSection?.widget_index
          ].deep_dive_on = null;
        } else {
          panes[index].section[0].widgets[
            selectedSection?.widget_index
          ].graphData = null;

          panes[index].section[0].widgets[
            selectedSection?.widget_index
          ].persist_graphdata = null;

          panes[index].section[0].widgets[
            selectedSection?.widget_index
          ].deep_dive_on = null;
        }

        // Non-Section Case / Edit widget in dashboard case
        if (widget_metadata?.is_widget_edited && !noteEdited) {
          if (widgetsClearFilter) {
            if (
              selectedSection?.section_index !== null &&
              selectedSection?.section_index >= 0
            ) {
              let updatePanes = [...panes];
              updatePanes[index].sections[
                selectedSection?.section_index
              ].widgets[selectedSection?.widget_index].graphData = null;

              // To clear persist_graphdata
              updatePanes[index].sections[
                selectedSection?.section_index
              ].widgets[selectedSection?.widget_index].persist_graphdata = null;

              // To clear deep_dive_on
              updatePanes[index].sections[
                selectedSection?.section_index
              ].widgets[selectedSection?.widget_index].deep_dive_on = null;

              // To clear filters
              updatePanes[index].sections[
                selectedSection?.section_index
              ].widgets[selectedSection?.widget_index].filters = finalFilters;

              // Clear Brands
              updatePanes[index].sections[
                selectedSection?.section_index
              ].widgets[selectedSection?.widget_index].brand_ids = null;
              updatePanes[index].sections[
                selectedSection?.section_index
              ].widgets[selectedSection?.widget_index].brand_groups = null;

              // Clear Duration
              updatePanes[index].sections[
                selectedSection?.section_index
              ].widgets[selectedSection?.widget_index].start_date = null;
              updatePanes[index].sections[
                selectedSection?.section_index
              ].widgets[selectedSection?.widget_index].end_date = null;

              // console.log("updatePanes", updatePanes);
              dispatch({ type: "SET_WIDGET_GRAPH_DATA", panes: updatePanes });
            } else {
              let updatePanes = [...panes];
              updatePanes[index].section[0].widgets[
                selectedSection?.widget_index
              ].graphData = null;

              // To clear persist_graphdata
              updatePanes[index].section[0].widgets[
                selectedSection?.widget_index
              ].persist_graphdata = null;

              // To clear deep_dive_on
              updatePanes[index].section[0].widgets[
                selectedSection?.widget_index
              ].deep_dive_on = null;

              // Clear Filters
              updatePanes[index].section[0].widgets[
                selectedSection?.widget_index
              ].filters = finalFilters;

              // Clear Brands
              updatePanes[index].section[0].widgets[
                selectedSection?.widget_index
              ].brand_ids = null;
              updatePanes[index].section[0].widgets[
                selectedSection?.widget_index
              ].brand_groups = null;

              // Clear Duration
              updatePanes[index].section[0].widgets[
                selectedSection?.widget_index
              ].start_date = null;
              updatePanes[index].section[0].widgets[
                selectedSection?.widget_index
              ].end_date = null;

              // console.log("updatePanes", updatePanes);
              dispatch({ type: "SET_WIDGET_GRAPH_DATA", panes: updatePanes });
            }
          } else {
            if (
              selectedSection?.section_index !== null &&
              selectedSection?.section_index >= 0
            ) {
              // To update filters
              updatePanes[index].sections[
                selectedSection?.section_index
              ].widgets[selectedSection?.widget_index].filters = finalFilters;

              // Brand logic
              let single_brands = [];
              let brandsGroupName = [];
              if (brandFilter) {
                brandFilter?.length > 0 &&
                  brandFilter[0]?.columns?.forEach((el) => {
                    if (el?.group) {
                      brandsGroupName.push({
                        brand_group_name: el?.brand_group_name,
                      });
                    }
                  });
              }

              if (brandFilter) {
                brandFilter?.length > 0 &&
                  brandFilter[0]?.columns?.forEach((el) => {
                    if (!el?.group) {
                      single_brands.push({
                        brand_id: el?.brand_id ? el?.brand_id : el?.name,
                        brand_name: el?.brand_name
                          ? el?.brand_name
                          : el?.brand_friendly_name,
                      });
                    }
                  });
              }

              // Update Brands
              updatePanes[index].sections[
                selectedSection?.section_index
              ].widgets[selectedSection?.widget_index].brand_ids =
                single_brands && single_brands[0]?.brand_id
                  ? single_brands
                  : null;
              updatePanes[index].sections[
                selectedSection?.section_index
              ].widgets[selectedSection?.widget_index].brand_groups =
                brandsGroupName?.length ? brandsGroupName : null;

              // Update Duration
              updatePanes[index].sections[
                selectedSection?.section_index
              ].widgets[selectedSection?.widget_index].start_date =
                finalFilters && finalFilters[0]?.attribute === "CreatedDate"
                  ? finalFilters[0]?.columns?.from
                  : null;
              updatePanes[index].sections[
                selectedSection?.section_index
              ].widgets[selectedSection?.widget_index].end_date =
                finalFilters && finalFilters[0]?.attribute === "CreatedDate"
                  ? finalFilters[0]?.columns?.to
                  : null;

              dispatch({ type: "SET_WIDGET_GRAPH_DATA", panes: updatePanes });
            } else {
              // To update filters
              updatePanes[index].section[0].widgets[
                selectedSection?.widget_index
              ].filters = finalFilters;

              // Brand logic
              let single_brands = [];
              let brandsGroupName = [];
              if (brandFilter) {
                brandFilter?.length > 0 &&
                  brandFilter[0]?.columns?.forEach((el) => {
                    if (el?.group) {
                      brandsGroupName.push({
                        brand_group_name: el?.brand_group_name,
                      });
                    }
                  });
              }

              if (brandFilter) {
                brandFilter?.length > 0 &&
                  brandFilter[0]?.columns?.forEach((el) => {
                    if (!el?.group) {
                      single_brands.push({
                        brand_id: el?.brand_id ? el?.brand_id : el?.name,
                        brand_name: el?.brand_name
                          ? el?.brand_name
                          : el?.brand_friendly_name,
                      });
                    }
                  });
              }

              // Update Brands
              updatePanes[index].section[0].widgets[
                selectedSection?.widget_index
              ].brand_ids =
                single_brands && single_brands[0]?.brand_id
                  ? single_brands
                  : null;
              updatePanes[index].section[0].widgets[
                selectedSection?.widget_index
              ].brand_groups = brandsGroupName?.length ? brandsGroupName : null;

              // Update Duration
              updatePanes[index].section[0].widgets[
                selectedSection?.widget_index
              ].start_date =
                finalFilters && finalFilters[0]?.attribute === "CreatedDate"
                  ? finalFilters[0]?.columns?.from
                  : null;
              updatePanes[index].section[0].widgets[
                selectedSection?.widget_index
              ].end_date =
                finalFilters && finalFilters[0]?.attribute === "CreatedDate"
                  ? finalFilters[0]?.columns?.to
                  : null;

              dispatch({ type: "SET_WIDGET_GRAPH_DATA", panes: updatePanes });
            }
          }
        } else {
          authParams &&
            dispatch(
              setUpdateFiltersInWidget(
                authParams,
                widget?.childId ? widget?.childId : widget_id,
                finalFilters,
                paneObj,
                selectedSection?.is_locked,
                widgetsClearFilter,
                clearBrandAndDuration
              )
            );
        }
      }
    } else if (type === "share_modal") {
      let updateShareTemplateData = { ...shareTemplateData };

      let shareObj = {
        shareBrands: shareBrands,

        shareData: updateShareTemplateData,
        shareCategory: shareCategory,
        graphConditionConfig: graphConditionConfig,
      };

      dispatch(setClearGraphData(null, null, "share", shareObj));

      // to set global selected widget in redux state to scroll that widget
      dispatch(setGlobalSelectedWidgetId(visitedWidgetId));

      // to clear selected widget deepdive for shared dashboard
      shareBrands && dispatch(setShareSelectedDeepdiveWidget(null));
      if (filterClear) {
        let filters = [];
        let comp_hidden_filter =
          shareTemplateData?.comp_hidden_filter &&
          !shareTemplateData?.private_conversation
            ? [...shareTemplateData?.comp_hidden_filter]
            : [];

        if (
          shareTemplateData?.private_conversation &&
          shareTemplateData?.comp_hidden_filter?.length &&
          shareTemplateData?.template_type === "competition"
        ) {
          let filters = getPrivateConversationFilters(
            shareTemplateData?.comp_hidden_filter,
            shareTemplateData?.filters ? shareTemplateData?.filters : []
          );

          updateShareTemplateData.filters = filters;
          updateShareTemplateData.private_conversation = false;
          dispatch({
            type: "SET_SHARE_TEMPLATE_DATA",
            payload: updateShareTemplateData,
          });
          callNotification(
            "Filters updated by excluding Private conversations",
            "info "
          );
        } else if (comp_hidden_filter?.length) {
          filters = comp_hidden_filter;
          callNotification(
            "Filters updated by excluding Private conversations",
            "info"
          );
        }

        // Add selectedPill handling to match global_dashboard
        if (
          selectedPill !== undefined &&
          selectedPill[0] &&
          Object.keys(selectedPill?.[0])?.length > 0
        ) {
          if (
            shareTemplateData?.template_type === "competition" &&
            !shareTemplateData.private_conversation
          ) {
            filters = mergeArrays(
              deepCopy([...comp_hidden_filter]),
              deepCopy([...selectedPill[0]?.saved_filters])
            );
            if (shareTemplateData?.saved_filters?.length) {
              let mergedFilters = getPrivateConversationFilters(
                shareTemplateData?.comp_hidden_filter,
                shareTemplateData?.saved_filters,
                shareTemplateData?.saved_filters
              );
              filters = [...filters, ...mergedFilters];
            }
          } else if (shareTemplateData?.hidden_filter?.attribute) {
            let hiddenAttribute =
              shareTemplateData?.hidden_filter?.attribute?.toLowerCase();
            let saved_filters = shareTemplateData?.saved_filters?.length
              ? shareTemplateData?.saved_filters
              : [];
            filters = [...selectedPill[0].saved_filters];
            if (saved_filters?.length) {
              filters = mergeArrays(deepCopy(filters), deepCopy(saved_filters));
            }
            if (filters.length) {
              filters = filters.filter(
                (item) => item?.attribute?.toLowerCase() !== hiddenAttribute
              );
            }
          } else {
            filters = [...selectedPill[0].saved_filters];
            if (shareTemplateData?.saved_filters?.length) {
              let mergedFilters = getPrivateConversationFilters(
                shareTemplateData?.comp_hidden_filter,
                shareTemplateData?.saved_filters,
                shareTemplateData?.saved_filters
              );
              filters = [...filters, ...mergedFilters];
            }
          }
        } else if (shareTemplateData?.saved_filters?.length) {
          let mergedFilters = getPrivateConversationFilters(
            shareTemplateData?.comp_hidden_filter,
            shareTemplateData?.saved_filters,
            shareTemplateData?.saved_filters
          );
          filters = [...mergedFilters];
        }
        updateShareTemplateData.filters = filters?.length ? filters : [];
      } else {
        updateShareTemplateData.filters = value;
      }
      dispatch({
        type: "SET_SHARE_TEMPLATE_DATA",
        payload: updateShareTemplateData,
      });
      // we are call api through getTemplateFilter, so here we stop previous api calls because here we perform global level changes
      window?.stop();
    } else if (type === "command_center_global") {
      if (authParams?.screen_id === "000-000-557") {
        let screenData = { ...screen };
        let widgetData = screenData?.widgets?.length
          ? screenData?.widgets?.[0]
          : screenData?.stream_screen_default_widget;
        let updatedScreenWidgets = screenData?.widgets?.length
          ? screenData?.widgets
          : [];
        let selectedBrand = screenData?.stream_screen_brand
          ? screenData?.stream_screen_brand
          : null;

        let finalFilter = widgetsClearFilter ? [] : [...value];
        let uniqueFilters = getUniqueFilters(finalFilter);

        let defaultOrderBy = {
          attribute: "CreatedDate",
          no_of_rows: 24,
          offset: 0,
          sort_order: "desc",
        };
        updatedScreenWidgets?.unshift({
          ...widgetData,
          graphData: null,
          persist_graphdata: null,
          deep_dive_on: null,
          oldGraphData: null,
          order_by: defaultOrderBy,
          brand_ids: selectedBrand,
          filters: uniqueFilters ? uniqueFilters : [],
          is_locked: true,
          column_widget_id: uuid(),
        });
        // console.log("command_center_global", updatedScreenWidgets);

        screenData = {
          ...screenData,
          widgets: updatedScreenWidgets?.length ? updatedScreenWidgets : [],
        };
        dispatch(setScreenUpdatedData(screenData));

        window?.localStorage?.setItem(
          "stream_screen_widgets",
          JSON.stringify(updatedScreenWidgets)
        );

        // To Clear stream screen filters and Selected Brand
        dispatch(setStreamScreenBrand(null));
        dispatch(setStreamScreenFilters([]));
        dispatch(setEditPanel(null));

        if (updatedScreenWidgets?.length > 1) {
          const element = document.getElementById("stream-content");
          element.scrollLeft = 1;
        }
      } else {
        let finalFilter = widgetsClearFilter ? [] : [...value];
        let uniqueFilters = getUniqueFilters(finalFilter);
        // Reset Category screen filters
        if (
          screenId === "000-000-552" ||
          authParams?.screen_id === "000-000-552"
        ) {
          let updatedFilters = [];
          dispatch(setCategoryScreenFilters(updatedFilters));
        }
        if (screensWithPersistedFilters.includes(authParams?.screen_id)) {
          let screenData = JSON.parse(
            window.localStorage.getItem(`screen_${authParams?.screen_id}`)
          );
          if (Object.keys(screenData)?.length) {
            screenData.filters = [...uniqueFilters];
            window.localStorage.setItem(
              `screen_${authParams?.screen_id}`,
              JSON.stringify(screenData)
            );
          }
        }

        // we are call api through making graphData clear/null, so here we stop previous api calls because here we perform global level changes
        window?.stop();
        dispatch(setGlobalFiltersInScreen(uniqueFilters));
        dispatch(setClearAllScreenWidgetGraphData());
      }
    } else if (selectedSection?.type === "command_center_widget") {
      if (authParams?.screen_id === "000-000-557") {
        let screenData = { ...screen };
        let selectedBrand = widgetsClearFilter
          ? null
          : screenData?.stream_screen_brand
          ? screenData?.stream_screen_brand
          : null;
        let widget_metadata =
          screenData?.widgets?.[editPanelInfo?.widget_index];
        let finalFilter = widgetsClearFilter ? [] : [...value];
        let uniqueFilters = getUniqueFilters(finalFilter);
        let updatedScreenWidgets = [];

        updatedScreenWidgets = screenData?.widgets?.map((d) => {
          let updatedOrderBy = {
            ...d?.order_by,
            offset: 0,
          };
          if (d?.column_widget_id === widget_metadata?.column_widget_id) {
            d.graphData = null;
            d.persist_graphdata = null;
            d.deep_dive_on = null;
            d.oldGraphData = null;
            d.order_by = updatedOrderBy;
            if (selectedBrand) d.brand_ids = selectedBrand;
            d.filters = uniqueFilters ? uniqueFilters : [];
          }
          return d;
        });
        // console.log("command_center_widget", updatedScreenWidgets);

        screenData = {
          ...screenData,
          widgets: updatedScreenWidgets?.length ? updatedScreenWidgets : [],
        };
        dispatch(setScreenUpdatedData(screenData));

        window?.localStorage?.setItem(
          "stream_screen_widgets",
          JSON.stringify(updatedScreenWidgets)
        );

        // To Clear stream screen filters and Selected Brand
        dispatch(setStreamScreenBrand(null));
        dispatch(setStreamScreenFilters([]));
        dispatch(setEditPanel(null));
      } else {
        let finalFilter = widgetsClearFilter ? [] : [...value];
        let uniqueFilters = getUniqueFilters(finalFilter);

        //update widgets filter in localstorage
        if (screensWithPersistedFilters.includes(authParams?.screen_id)) {
          let screenData = JSON.parse(
            window.localStorage.getItem(`screen_${authParams?.screen_id}`)
          );
          if (Object.keys(screenData)?.length) {
            screenData.widgets[editPanelInfo.widget_index].filters = [
              ...uniqueFilters,
            ];
            window.localStorage.setItem(
              `screen_${authParams?.screen_id}`,
              JSON.stringify(screenData)
            );
          }
        }
        dispatch(
          updateScreenWidgetPropdataWithClearGraphData(
            selectedSection?.section_index,
            selectedSection?.widget_index,
            {
              prop_name: "filters",
              prop_value: uniqueFilters,
            }
          )
        );
      }
    } else if (type === "deep_dive_global") {
      if (typeof resetDeepdiveDataOnInitial === "function")
        resetDeepdiveDataOnInitial();
      let tabName = isDetailedInsightVisible?.name;
      let finalFilter = widgetsClearFilter ? [] : [...value];
      let uniqueFilters = getUniqueFilters(finalFilter);
      const deepDiveObj = {
        ...deepdive_object,
        filters: uniqueFilters,
        tabName: tabName,
      };
      dispatch(setDeepDiveObject(deepDiveObj));
      dispatch(setDeepDiveMentionsObject(deepDiveObj));
      dispatch(setDeepDiveInfluencersObject(deepDiveObj));
      let widget_ids =
        tabName === "Mentions"
          ? ["info-bar", "1.1", "1.2"]
          : tabName === "Word Cloud"
          ? ["info-bar", "2.1", "2.2", "2.3", "2.4"]
          : tabName === "Category"
          ? ["info-bar", "3.2", "3.3", "3.4", "3.5"]
          : tabName === "Influencers"
          ? ["info-bar", "4.1"]
          : tabName === "Source of Post"
          ? ["info-bar", "5.1", "5.2", "5.3", "5.4"]
          : tabName === "Location Profiles"
          ? ["info-bar", "7.1"]
          : ["info-bar", "1.1", "1.2"];
      dispatch(setDeepDiveInfoLoader(true));
      dispatch(
        getDeepDive(
          authParams,
          deepDiveObj,
          widget_ids,
          query?.get("share_id"),
          uniqueFilters
        )
      );
    }

    setwidgetsClearFilter && setwidgetsClearFilter(false);
    dispatch(
      setFilterObject({
        id: null,
        type: null,
        section_index: null,
        widget_index: null,
        is_locked: null,
      })
    );
    setisDone(false);
    setfilterSearch("");
    dispatch(setIsWidgetEdit(false));
    dispatch(setIsNetworkWidgetSettingEdit(false));
    dispatch(setNetworkWidgetSettingObject(null));
    dispatch(setDashboardDateFilterObj(null));
    dispatch(setDashboardBrandObj(null));
    dispatch(setCompetitorBrandType("initial"));
    dispatch(setTemplateFiltersObj(null));
    dispatch(setTemplateBrandObj(null));
    dispatch(setPdfEditorPanel(false, "filter", templateObj));
    setCheckedValue({
      type: "",
      name: "",
      attribute: "",
      datatype: "",
    });

    // to close or collapse accordion list
    dispatch(setFilterActiveKey([]));
    setNoteEdited(false);
  };
  useEffect(() => {
    //this is to reset filter values according to types
    resetState();
  }, [type, graphDetail?.filter, visible, panes]);

  const resetState = () => {
    let index = getPaneIndex(panes, activeKeys);
    let global_filters = panes[index]?.filters
      ? panes[index]?.filters
      : panes[index]?.globalFilters;
    let share_global_filters = shareTemplateData?.filters
      ? shareTemplateData?.filters
      : null;

    let section_filters =
      editPanelInfo?.type === "dashboard_section" && panes[index]?.sections
        ? panes[index]?.sections[editPanelInfo?.section_index]?.filters
        : null;
    let widget_filters =
      editPanelInfo?.type === "dashboard_widget" && panes[index]?.sections
        ? panes[index]?.sections[editPanelInfo?.section_index]?.widgets &&
          panes[index]?.sections[editPanelInfo?.section_index]?.widgets[
            editPanelInfo?.widget_index
          ]?.filters
        : editPanelInfo?.type === "dashboard_widget" && panes[index]?.section
        ? panes[index]?.section &&
          panes[index]?.section[0]?.widgets &&
          panes[index]?.section &&
          panes[index]?.section[0]?.widgets[editPanelInfo?.widget_index]
            ?.filters
        : null;
    let template_filters = templateDetails?.templateFilters;
    let template_section_filters =
      Section &&
      editPanelInfo?.type === "template_section" &&
      editPanelInfo?.section_index >= 0 &&
      Section[editPanelInfo?.section_index]?.filters;
    let template_widget_filters =
      editPanelInfo?.type === "template_widget" &&
      editPanelInfo?.section_index >= 0 &&
      editPanelInfo?.widget_index >= 0 &&
      Section &&
      Section[editPanelInfo?.section_index]?.data &&
      Section[editPanelInfo?.section_index]?.data[editPanelInfo?.widget_index]
        ?.filters;

    if (type === "global_dashboard") {
      let obj = resetRadio(global_filters);
      let updateRadioArray = radioArray;
      setTextAtt(obj?.textAttribute);
      setInputVal(obj?.inputVal);
      setInputValArr(obj?.inputValArr);
      setBoolRadioChecked(obj.radio);
      dispatch(setCheckedArray(obj.checkedArray));
      updateRadioArray[type].data = obj?.arr;
      dispatch(setradioArray(updateRadioArray));
      let updateRadioChecked = radioChecked;
      updateRadioChecked[type].data = obj?.radio;

      dispatch(setradioChecked(updateRadioChecked));
      setRadioChecked(updateRadioChecked);
    }
    if (type === "dashboard_section") {
      let obj = resetRadio(section_filters);
      let updateRadioArray = radioArray;
      updateRadioArray[type].data = obj?.arr;
      setTextAtt(obj?.textAttribute);
      setInputVal(obj?.inputVal);
      setInputValArr(obj?.inputValArr);
      dispatch(setradioArray(updateRadioArray));
      let updateRadioChecked = radioChecked;
      updateRadioChecked[type].data = obj?.radio;

      dispatch(setradioChecked(updateRadioChecked));
      setRadioChecked(updateRadioChecked);
    }

    if (type === "dashboard_widget") {
      let obj = resetRadio(widget_filters, filterData);

      setTextAtt(obj?.textAttribute);
      setInputVal(obj?.inputVal);
      setInputValArr(obj?.inputValArr);
      let updateRadioArray = radioArray;
      updateRadioArray[type].data = obj?.arr;
      dispatch(setradioArray({ ...updateRadioArray }));
      setTextAtt(obj?.textAttribute);
      let updateRadioChecked = radioChecked;
      updateRadioChecked[type].data = obj?.radio;
      // dispatch(setChecked(obj?.radio));
      dispatch(setChecked(obj?.checkbox));

      dispatch(setCheckedArray(obj.checkedArray));

      dispatch(setradioChecked(updateRadioChecked));
      setRadioChecked(updateRadioChecked);
    }
    if (type === "template_global") {
      let obj = resetRadio(templateDetails?.templateFilters);
      setTextAtt(obj?.textAttribute);
      setInputVal(obj?.inputVal);
      setInputValArr(obj?.inputValArr);
      let updateRadioArray = radioArray;
      updateRadioArray[type].data = obj?.arr;
      dispatch(setradioArray(updateRadioArray));

      let updateRadioChecked = radioChecked;
      updateRadioChecked[type].data = obj?.radio;

      dispatch(setradioChecked(updateRadioChecked, updateRadioChecked));
      setRadioChecked(updateRadioChecked);
    }
    if (
      type === "template_section" ||
      selectedSection?.type === "template_section"
    ) {
      let obj = resetRadio(template_section_filters);
      setTextAtt(obj?.textAttribute);
      setInputVal(obj?.inputVal);
      setInputValArr(obj?.inputValArr);
      let updateRadioArray = radioArray;
      updateRadioArray[type].data = obj?.arr;
      dispatch(setradioArray(updateRadioArray));
      let updateRadioChecked = radioChecked;
      updateRadioChecked[type].data = obj?.radio;

      dispatch(setradioChecked(updateRadioChecked));
      setRadioChecked(updateRadioChecked);
    }
    if (
      type === "template_widget" ||
      selectedSection?.type === "template_widget"
    ) {
      let obj = resetRadio(template_widget_filters, filterData);
      setTextAtt(obj?.textAttribute);
      setInputVal(obj?.inputVal);
      setInputValArr(obj?.inputValArr);
      let updateRadioArray = radioArray;
      updateRadioArray[type].data = obj?.arr;
      setTextAtt(obj?.textAttribute);
      dispatch(setradioArray(updateRadioArray));
      let updateRadioChecked = radioChecked;
      updateRadioChecked[type].data = obj?.radio;
      dispatch(setChecked(obj?.checkbox));
      dispatch(setCheckedArray(obj.checkedArray));
      dispatch(setradioChecked(updateRadioChecked));
      setRadioChecked(updateRadioChecked);
    }
    if (type === "graph_page") {
      let obj = resetRadio(graphDetail?.filter ? graphDetail?.filter : []);
      setTextAtt(obj?.textAttribute);
      setInputVal(obj?.inputVal);
      setInputValArr(obj?.inputValArr);
      let updateRadioArray = radioArray;
      updateRadioArray[type].data = obj?.arr;
      dispatch(setradioArray(updateRadioArray));
      let updateRadioChecked = radioChecked;
      updateRadioChecked[type].data = obj?.radio;

      dispatch(setradioChecked(updateRadioChecked));
      setRadioChecked(updateRadioChecked);
    }
    if (type?.split("_")[0] === "y") {
      let obj = resetRadio(
        axisPanelAtt[`y_axis`][type].filters
          ? axisPanelAtt[`y_axis`][type].filters
          : []
      );
      setTextAtt(obj?.textAttribute);
      setInputVal(obj?.inputVal);
      setInputValArr(obj?.inputValArr);
      let updateRadioArray = radioArray;
      updateRadioArray[type].data = obj?.arr;
      dispatch(setradioArray(updateRadioArray));
      let updateRadioChecked = radioChecked;
      updateRadioChecked[type].data = obj?.radio;
      dispatch(setradioChecked(updateRadioChecked));
      setRadioChecked(updateRadioChecked);
    }

    if (type?.split("_")[0] === "kpi") {
      // Updated the object to show applied filters on selected KPI
      let obj;
      axisPanelAtt?.card_settings?.map((d) => {
        if (d?.card_name === Number(type?.split("_")[2])) {
          obj = resetRadio(d?.y_series?.filters ? d?.y_series?.filters : []);
        }
      });

      // let obj = resetRadio(
      //   axisPanelAtt?.card_settings[Number(type?.split("_")[2] - 1)]?.y_series
      //     ?.filters
      //     ? axisPanelAtt?.card_settings[Number(type?.split("_")[2] - 1)]
      //         ?.y_series?.filters
      //     : []
      // );
      setTextAtt(obj?.textAttribute);
      setInputVal(obj?.inputVal);
      setInputValArr(obj?.inputValArr);
      let updateRadioArray = radioArray;
      updateRadioArray[type].data = obj?.arr;
      dispatch(setradioArray(updateRadioArray));
      let updateRadioChecked = radioChecked;
      updateRadioChecked[type].data = obj?.radio;
      dispatch(setradioChecked(updateRadioChecked));
      setRadioChecked(updateRadioChecked);
    }
    if (type === "widgetMaker") {
      let obj = resetRadio(axisPanelAtt?.filters);
      setTextAtt(obj?.textAttribute);
      setInputVal(obj?.inputVal);
      setInputValArr(obj?.inputValArr);
      let updateRadioArray = radioArray;
      updateRadioArray[type].data = obj?.arr;
      dispatch(setradioArray(updateRadioArray));
      let updateRadioChecked = radioChecked;
      updateRadioChecked[type].data = obj?.radio;
      dispatch(setradioChecked(updateRadioChecked));
      setRadioChecked(updateRadioChecked);

      setBoolRadioChecked(obj.radio);
      dispatch(setCheckedArray(obj.checkedArray));
    }
    if (type === "share_modal") {
      let obj = resetRadio(share_global_filters);
      let updateRadioArray = radioArray;
      setTextAtt(obj?.textAttribute);
      setInputVal(obj?.inputVal);
      setInputValArr(obj?.inputValArr);
      setBoolRadioChecked(obj.radio);
      dispatch(setCheckedArray(obj.checkedArray));
      updateRadioArray[type].data = obj?.arr;
      dispatch(setradioArray(updateRadioArray));
      let updateRadioChecked = radioChecked;
      updateRadioChecked[type].data = obj?.radio;

      dispatch(setradioChecked(updateRadioChecked));
      setRadioChecked(updateRadioChecked);
    }
    if (type === "command_center_global") {
      let global_screen_filters =
        screen?.filters && Array.isArray(screen?.filters)
          ? screen?.filters
          : [];

      let obj = resetRadio(global_screen_filters);
      let updateRadioArray = radioArray;
      setTextAtt(obj?.textAttribute);
      setInputVal(obj?.inputVal);
      setInputValArr(obj?.inputValArr);
      setBoolRadioChecked(obj.radio);
      dispatch(setCheckedArray(obj.checkedArray));
      updateRadioArray[type].data = obj?.arr;
      dispatch(setradioArray(updateRadioArray));
      let updateRadioChecked = radioChecked;
      updateRadioChecked[type].data = obj?.radio;
      dispatch(setradioChecked(updateRadioChecked));
      setRadioChecked(updateRadioChecked);
    }
    if (
      type === "command_center_section" ||
      selectedSection?.type === "command_center_section"
    ) {
      let section_filters =
        selectedSection?.section_index !== null &&
        selectedSection?.section_index !== undefined &&
        screen?.sections &&
        screen?.sections?.[selectedSection?.section_index]
          ? screen?.sections?.[selectedSection?.section_index]?.filters
          : selectedSection?.section_index >= 0 &&
            screen?.sections &&
            screen?.sections?.[selectedSection?.section_index]
          ? screen?.sections?.[selectedSection?.section_index]?.filters
          : screen?.section && screen?.section?.[0]
          ? screen?.section?.[0]?.filters
          : null;
      let obj = resetRadio(section_filters);
      let updateRadioArray = radioArray;
      updateRadioArray[type].data = obj?.arr;
      setTextAtt(obj?.textAttribute);
      setInputVal(obj?.inputVal);
      setInputValArr(obj?.inputValArr);
      dispatch(setradioArray(updateRadioArray));
      let updateRadioChecked = radioChecked;
      updateRadioChecked[type].data = obj?.radio;

      dispatch(setradioChecked(updateRadioChecked));
      setRadioChecked(updateRadioChecked);
    }
    if (
      type === "command_center_widget" ||
      selectedSection?.type === "command_center_widget"
    ) {
      let widget_filters =
        selectedSection?.section_index !== null &&
        selectedSection?.section_index !== undefined &&
        screen?.sections &&
        screen?.sections?.[selectedSection?.section_index]?.widgets?.[
          selectedSection?.widget_index
        ]
          ? screen?.sections?.[selectedSection?.section_index]?.widgets?.[
              selectedSection?.widget_index
            ]?.filters
          : selectedSection?.section_index >= 0 &&
            screen?.sections &&
            screen?.sections?.[selectedSection?.section_index]
          ? screen?.sections?.[selectedSection?.section_index]?.filters
          : screen?.section?.[0]?.widgets?.[selectedSection?.widget_index]
          ? screen?.section?.[0]?.widgets?.[selectedSection?.widget_index]
              ?.filters
          : screen?.widgets && screen?.widgets?.[selectedSection?.widget_index]
          ? screen?.widgets?.[selectedSection?.widget_index]?.filters
          : null;
      let obj = resetRadio(widget_filters, filterData);

      setTextAtt(obj?.textAttribute);
      setInputVal(obj?.inputVal);
      setInputValArr(obj?.inputValArr);
      let updateRadioArray = radioArray;
      updateRadioArray[type].data = obj?.arr;
      dispatch(setradioArray({ ...updateRadioArray }));
      setTextAtt(obj?.textAttribute);
      let updateRadioChecked = radioChecked;
      updateRadioChecked[type].data = obj?.radio;
      // dispatch(setChecked(obj?.radio));
      dispatch(setChecked(obj?.checkbox));
      dispatch(setCheckedArray(obj?.checkedArray));
      dispatch(setradioChecked(updateRadioChecked));
      setRadioChecked(updateRadioChecked);
    }

    if (type === "deep_dive_global") {
      let global_deepdive_filters =
        deepdive_object?.filters && Array.isArray(deepdive_object?.filters)
          ? deepdive_object?.filters
          : [];

      let obj = resetRadio(global_deepdive_filters);
      let updateRadioArray = radioArray;
      setTextAtt(obj?.textAttribute);
      setInputVal(obj?.inputVal);
      setInputValArr(obj?.inputValArr);
      setBoolRadioChecked(obj.radio);
      dispatch(setCheckedArray(obj.checkedArray));
      updateRadioArray[type].data = obj?.arr;
      dispatch(setradioArray(updateRadioArray));
      let updateRadioChecked = radioChecked;
      updateRadioChecked[type].data = obj?.radio;
      dispatch(setradioChecked(updateRadioChecked));
      setRadioChecked(updateRadioChecked);
    }
  };

  const resetStateForTemplate = (filters) => {
    let quickTemplateFilters = filters;
    if (type === "global_dashboard") {
      let obj = resetRadio(quickTemplateFilters);
      let updateRadioArray = radioArray;
      setTextAtt(obj?.textAttribute);
      setInputVal(obj?.inputVal);
      setInputValArr(obj?.inputValArr);
      setBoolRadioChecked(obj.radio);
      dispatch(setCheckedArray(obj.checkedArray));
      updateRadioArray[type].data = obj?.arr;
      dispatch(setradioArray(updateRadioArray));
      let updateRadioChecked = radioChecked;
      updateRadioChecked[type].data = obj?.radio;

      dispatch(setradioChecked(updateRadioChecked));
      setRadioChecked(updateRadioChecked);
    }
  };

  useEffect(() => {
    if (widgetsClearFilter) {
      onFilterClear();
    }
  }, [widgetsClearFilter]);

  useEffect(() => {
    // Initialize input value based on quickFilterModalVisible.type
    if (quickFilterModalVisible.type === "duplicate") {
      let newTitle = `${filterTemplatePayload.title} duplicate`;
      if (newTitle.length > 25) {
        newTitle = newTitle.slice(0, 25);
      }
      setTitleInputValue(newTitle);
      setFilterTemplatePayload((prev) => ({
        ...prev,
        title: `${newTitle}`,
      }));
    } else {
      setTitleInputValue(filterTemplatePayload.title);
    }
  }, [quickFilterModalVisible.type]);

  useEffect(() => {
    setfilterSearch("");
  }, [currentTab]);

  useEffect(() => {
    if (
      !radioArray?.["global_dashboard"]?.data?.length &&
      !inputValArr?.length &&
      !textAtt?.length
    ) {
      setAsAnyFilterApplied(false);
    } else if (radioArray?.["global_dashboard"]?.data?.length) {
      setAsAnyFilterApplied(true);
    } else if (inputValArr?.length) {
      setAsAnyFilterApplied(true);
    } else if (textAtt?.length) {
      setAsAnyFilterApplied(true);
    }
  }, [
    radioArray["global_dashboard"],
    radioChecked,
    inputValArr,
    textAtt,
    checkedState,
    radioValue,
    checkedValue,
  ]);
  const GlobalFilter = useMemo(() => {
    if (type === "deep_dive_global") {
      return deepdive_object?.filters || [];
    } else if (type === "command_center_global") {
      return screen?.filters || [];
    } else if (type === "global_dashboard") {
      return panes?.[index]?.filters || [];
    } else if (type === "share_modal") {
      return shareTemplateData?.filters || [];
    } else {
      return templateDetails?.templateFilters || [];
    }
  }, [
    type,
    deepdive_object,
    screen,
    panes,
    shareTemplateData,
    templateDetails,
  ]);

  const savedFilters = useMemo(() => {
    if (type === "command_center_global") {
      return screen?.saved_filters || [];
    } else if (type === "global_dashboard") {
      return panes?.[index]?.saved_filters || [];
    } else if (type === "share_modal") {
      return shareTemplateData?.saved_filters || [];
    } else {
      return [];
    }
  }, [type, screen, panes, shareTemplateData]);

  const comHiddenFilter = useMemo(() => {
    if (type === "command_center_global" && !screen?.private_conversation) {
      return screen?.comp_hidden_filter || [];
    } else if (
      type === "global_dashboard" &&
      !panes?.[index]?.private_conversation
    ) {
      return panes?.[index]?.comp_hidden_filter || [];
    } else if (
      type === "share_modal" &&
      !shareTemplateData?.private_conversation
    ) {
      return shareTemplateData?.comp_hidden_filter || [];
    } else if (!templateDetails?.private_conversation) {
      return templateDetails?.comp_hidden_filter || [];
    } else {
      return [];
    }
  }, [type, screen, panes, shareTemplateData, templateDetails]);
  //clear filter Button Function, To clear selected filters
  const onFilterClear = () => {
    let index = getPaneIndex(panes, activeKeys);
    if (
      type === "global_dashboard" ||
      type === "template_global" ||
      type === "share_modal" ||
      type === "deep_dive_global" ||
      type === "command_center_global"
    ) {
      if (
        !GlobalFilter?.length &&
        !savedFilters?.length &&
        !comHiddenFilter?.length
      ) {
        onfilterclear();
        return;
      }
    }
    if (
      type !== "widgetMaker" &&
      panes[index]?.predefined &&
      panes[index]?.template_type === "ticket" &&
      ["000-000-002", "000-000-003"]?.includes(panes[index]?.template_id)
    ) {
      let filterPanelData = getFilterPanelData(
        panes[index]?.filterPanelData,
        panes[index]?.predefined
      );
      let resetChecked = resetCheckedState(
        panes[index]?.defaultFilters,
        filterPanelData
      );
      let checkedArr = {};
      let radioArr = [];
      panes[index]?.defaultFilters?.forEach((e) =>
        e?.columns?.forEach((el) => {
          checkedArr = {
            ...checkedArr,
            [e?.attribute]: [
              {
                name: el?.name,
                type: el?.type,
                attribute: e?.attribute,
                datatype: e?.type,
                data_source: e?.data_source || e?.source,
              },
            ],
          };
          radioArr = [
            ...radioArr,
            {
              name: el?.name,
              type: el?.type,
              attribute: e?.attribute,
              datatype: e?.type,
              data_source: e?.data_source || e?.source,
            },
          ];
        })
      );
      dispatch(setCheckedArray(checkedArr));
      dispatch(setChecked(resetChecked));

      let resetRadio = resetRadioState(
        panes[index]?.defaultFilters,
        filterPanelData
      );
      setBoolRadioChecked(resetRadio);
      dispatch(
        setradioArray({
          global_dashboard: { data: [...radioArr] },
          dashboard_section: { data: [] },
          dashboard_widget: { data: [] },
          template_global: { data: [] },
          template_section: { data: [] },
          template_widget: { data: [] },
          graph_page: { data: [] },
          orm_dashboard: { data: [] },
          widgetMaker: { data: [] },
          share_modal: { data: [] },
          y_series_1: { data: [] },
          y_series_2: { data: [] },
          y_series_3: { data: [] },
          y_series_4: { data: [] },
          y_series_5: { data: [] },
          kpi_card_1: { data: [] },
          kpi_card_2: { data: [] },
          kpi_card_3: { data: [] },
          kpi_card_4: { data: [] },
          kpi_card_5: { data: [] },
          kpi_card_6: { data: [] },
          kpi_card_7: { data: [] },
          kpi_card_8: { data: [] },
          kpi_card_9: { data: [] },
          kpi_card_10: { data: [] },
          kpi_card_11: { data: [] },
          kpi_card_12: { data: [] },
          kpi_card_13: { data: [] },
          kpi_card_14: { data: [] },
          kpi_card_15: { data: [] },
          command_center_global: { data: [] },
          command_center_section: { data: [] },
          command_center_widget: { data: [] },
          deep_dive_global: { data: [] },
        })
      );
    } else {
      setCheckedValue({
        type: "",
        name: "",
        attribute: "",
        datatype: "",
        data_source: "",
      });
      setMentionContent({});
      dispatch(
        setradioChecked({
          global_dashboard: { data: {} },
          dashboard_section: { data: {} },
          dashboard_widget: { data: {} },
          template_global: { data: {} },
          share_modal: { data: {} },
          template_section: { data: {} },
          template_widget: { data: {} },
          graph_page: { data: {} },
          orm_dashboard: { data: {} },
          widgetMaker: { data: {} },
          y_series_1: { data: {} },
          y_series_2: { data: {} },
          y_series_3: { data: {} },
          y_series_4: { data: {} },
          y_series_5: { data: {} },
          kpi_card_1: { data: {} },
          kpi_card_2: { data: {} },
          kpi_card_3: { data: {} },
          kpi_card_4: { data: {} },
          kpi_card_5: { data: {} },
          kpi_card_6: { data: {} },
          kpi_card_7: { data: {} },
          kpi_card_8: { data: {} },
          kpi_card_9: { data: {} },
          kpi_card_10: { data: {} },
          kpi_card_11: { data: {} },
          kpi_card_12: { data: {} },
          kpi_card_13: { data: {} },
          kpi_card_14: { data: {} },
          kpi_card_15: { data: {} },
          command_center_global: { data: {} },
          command_center_section: { data: {} },
          command_center_widget: { data: {} },
          deep_dive_global: { data: {} },
        })
      );

      let obj = {};
      slider &&
        Object.keys(slider)?.map((value) => {
          return value !== "attribute" && (obj[value] = [0, 1]);
        });
      setSlider(obj);
      dispatch(setFilterActiveKey([]));
      setslideValueobj({ value: [], attribute: "", type: "" });
      setslideArray([]);
      setdateValue({});

      setcurrentFilterPanelSelected([]);
      dispatch(
        setradioArray({
          global_dashboard: { data: [] },
          dashboard_section: { data: [] },
          dashboard_widget: { data: [] },
          template_global: { data: [] },
          share_modal: { data: [] },
          template_section: { data: [] },
          template_widget: { data: [] },
          graph_page: { data: [] },
          orm_dashboard: { data: [] },
          widgetMaker: { data: [] },
          y_series_1: { data: [] },
          y_series_2: { data: [] },
          y_series_3: { data: [] },
          y_series_4: { data: [] },
          y_series_5: { data: [] },
          kpi_card_1: { data: [] },
          kpi_card_2: { data: [] },
          kpi_card_3: { data: [] },
          kpi_card_4: { data: [] },
          kpi_card_5: { data: [] },
          kpi_card_6: { data: [] },
          kpi_card_7: { data: [] },
          kpi_card_8: { data: [] },
          kpi_card_9: { data: [] },
          kpi_card_10: { data: [] },
          kpi_card_11: { data: [] },
          kpi_card_12: { data: [] },
          kpi_card_13: { data: [] },
          kpi_card_14: { data: [] },
          kpi_card_15: { data: [] },
          command_center_global: { data: [] },
          command_center_section: { data: [] },
          command_center_widget: { data: [] },
          deep_dive_global: { data: [] },
        })
      );
      setradioValue({
        type: "",
        name: "",
        attribute: "",
        datatype: "",
        data_source: "",
      });
      setAttribute({
        attribute: "",
        shouldContain: [],
        or: [],
        donotHave: [],
      });
      setAddColumn({ name: [], type: "" });
      setAddColumnArray([]);
    }
    setAddColumnArray([]);
    setMentionContent([]);
    setTextAtt([]);
    setInputVal({});
    setInputValArr([]);
    if (type === "global_dashboard") {
      let quickFilter =
        panes?.[index]?.quick_filter === "Category"
          ? "CategoryID"
          : panes?.[index]?.quick_filter === "AccountID"
          ? "SettingID"
          : panes?.[index]?.quick_filter;

      // let filters = panes[index]?.filters ? panes[index]?.filters : [];
      // if (panes[index]?.quick_filter) {
      //   filters = filters?.filter((el) => quickFilter?.includes(el?.attribute));
      // }
      // if (panes[index]?.hidden_filter) {
      //   filters = filters?.filter((el) =>
      //     panes[index]?.hidden_filter?.attribute?.includes(el?.attribute)
      //   );
      // }
      // if (panes[index]?.comp_hidden_filter?.length) {
      //   filters = getPrivateConversationFilters(
      //     panes[index]?.comp_hidden_filter,
      //     filters
      //   );
      // }

      // let filters = [];
      // if (
      //   panes[index]?.comp_hidden_filter?.length &&
      //   !panes[index]?.private_conversation
      // ) {
      //   filters = [...filters, ...panes[index]?.comp_hidden_filter];
      // }
      // if (panes?.[index]?.saved_filters) {
      //   filters = [...filters, ...panes[index]?.saved_filters];
      // }
      // const updatePanes = [...panes];
      // updatePanes[index].filters = filters;
      //dispatch({ type: "SET_WIDGET_GRAPH_DATA", panes: updatePanes });
      // dispatch(
      //   setTemplateDetails(templateDetails, {
      //     filters: filters,
      //     quick_filter: [],
      //   })
      // );
      resetState();

      // to set global selected widget in redux state to scroll that widget
      dispatch(setGlobalSelectedWidgetId(visitedWidgetId));
    } else if (type === "template_global") {
      dispatch(setTemplateDetails(templateDetails, { filters: [] }));
    }
    setfilterClear(true);
    dispatch(setFilterActiveKey([]));

    if (authParams?.screen_id === "000-000-557") {
      // To Clear stream screen filters and Selected Brand
      dispatch(setStreamScreenBrand(null));
      dispatch(setStreamScreenFilters([]));
      dispatch(setEditPanel(null));
    }
  };

  // Cancel Button Function, To close filter modal
  const onfilterclear = () => {
    setSearchTerm(null);

    drawer && onClose();
    dispatch(setisFilterPanelVisible(false));
    setcurrentFilterPanelSelected([]);
    let filterDate;
    let updatedData = filterData?.filter((el) => {
      if (el?.title === "Date") filterDate = el;
      return el?.title !== "Date";
    });

    updatedData.push(filterDate);
    dispatch(setFilterPanelData(updatedData));
    dispatch(setFilterActiveKey([]));

    // To Clear stream screen filters and Selected Brand
    if (authParams?.screen_id === "000-000-557") {
      // To Clear stream screen filters and Selected Brand
      dispatch(setStreamScreenBrand(null));
      dispatch(setStreamScreenFilters([]));
      dispatch(setEditPanel(null));
    }
  };

  const collapseChange = (e, attribute, e_data) => {
    if (!e_data?.is_searchable && e_data?.values?.length > 5) {
      setSearchTerm({
        search: filterSearch ? filterSearch : "",
        key: attribute,
      });
    }
    dispatch(setFilterActiveKey(e));
    setcurrentFilterPanelSelected(e);
    dispatch(setFilterDateActiveKey(null));
    setFilterSearchTermIndex(e);
  };

  const onShouldContain = (tags, att, include, values) => {
    let totalLength = 0;
    if (values) {
      totalLength =
        (values?.donotHave?.length || 0) + (values?.or?.length || 0);
    }
    const separatedTags = createCommaSeparatedTags(tags, totalLength);
    const textData =
      textAtt?.length === 0 || !textAtt?.some((el) => el?.attribute === att)
        ? [...textAtt, { attribute: att, shouldContain: separatedTags }]
        : textAtt?.map((e) => {
            if (e?.attribute === att) {
              return {
                ...e,
                shouldContain: separatedTags,
              };
            } else {
              return e;
            }
          });
    setTextAtt([...textData, textData]);
    setAttribute({
      ...attribute,
      attribute: att,
      shouldContain: separatedTags,
    });
    setAddColumn({
      ...addColumn,
      name: separatedTags,
      type: include,
    });
  };

  const onOR = (tags, att, or, values) => {
    let totalLength = 0;
    if (values) {
      totalLength =
        (values?.shouldContain?.length || 0) + (values?.donotHave?.length || 0);
    }
    const separatedTags = createCommaSeparatedTags(tags, totalLength);
    let textData =
      textAtt?.length === 0 || !textAtt?.some((el) => el?.attribute === att)
        ? [...textAtt, { attribute: att, or: separatedTags }]
        : textAtt?.map((e) => {
            if (e?.attribute === att) {
              return {
                ...e,
                or: separatedTags,
              };
            } else {
              return e;
            }
          });
    setTextAtt([...textData]);
    setAttribute({
      ...attribute,
      attribute: att,
      or: separatedTags,
    });
    setAddColumn({
      ...addColumn,
      name: separatedTags,
      type: or,
    });
  };

  const onDonotHave = (tags, att, exclude, values) => {
    let totalLength = 0;
    if (values) {
      totalLength =
        (values?.shouldContain?.length || 0) + (values?.or?.length || 0);
    }
    const separatedTags = createCommaSeparatedTags(tags, totalLength);
    let textData =
      textAtt?.length === 0 || !textAtt?.some((el) => el?.attribute === att)
        ? [...textAtt, { attribute: att, donotHave: separatedTags }]
        : textAtt?.map((e) => {
            if (e?.attribute === att) {
              return {
                ...e,
                donotHave: separatedTags,
              };
            } else {
              return e;
            }
          });
    setTextAtt([...textData]);
    setAttribute({
      ...attribute,
      attribute: att,
      donotHave: separatedTags,
    });
    setAddColumn({
      ...addColumn,
      name: separatedTags,
      type: exclude,
    });
  };

  const handleDeleteTemplate = (template) => {
    // to show delete confirm modal with deleted template details
    setDeleteTemplateDetails({ filterTemplate: template, showModal: true });
  };

  const handleOk = (value) => {
    let isDeletedPillSelected = false;
    if (
      selectedPill &&
      selectedPill.length &&
      Object.keys(selectedPill[0]).length &&
      selectedPill[0]?.filter_template_id ===
        deleteTemplateDetails?.filterTemplate?.filter_template_id
    ) {
      isDeletedPillSelected = true;
    }
    dispatch(
      deleteFilterTemplate(
        authParams,
        panes,
        index,
        deleteTemplateDetails?.filterTemplate?.filter_template_id,
        deleteTemplateDetails?.filterTemplate?.filter_template_name
      )
    );
    if (
      quickFilterChecked[
        deleteTemplateDetails?.filterTemplate?.filter_template_id
      ]
    ) {
      setSelectedCount((prev) => prev - 1);
    }
    // condition to stop unnecessary chart calls if pinned template is not enabled when deleted.
    if (isDeletedPillSelected) {
      let paneObj = {
        panes: panes,
        activeKey: activeKeys,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        singleBrands: brands,
        authParams: authParams,
        index: index,
        competitorBrands: competitorBrands,
        graphConditionConfig: graphConditionConfig,
        is_modified_date:
          panes?.[index]?.template_id === "000-000-002" ||
          panes?.[index]?.template_id === "000-000-004"
            ? panes?.[index]?.is_modified_date
              ? panes?.[index]?.is_modified_date
              : false
            : null,
      };
      dispatch(setClearGraphData(index, panes, paneObj));
    }
    dispatch(setSelectedPillInPane({}, index, panes));
    setDeleteTemplateDetails({ filterTemplate: null, showModal: false });
  };

  const handleCancel = () => {
    setDeleteTemplateDetails({ filterTemplate: null, showModal: false });
  };

  const handleDuplicateTemplate = (template) => {
    resetStateForTemplate(template.saved_filters);
    setFilterTemplatePayload({
      title: template?.filter_template_name,
      id: template?.filter_template_id,
      description: template?.filter_template_description,
      payload: template?.saved_filters,
    });
    setTemplateEdit({
      forEdit: false,
      forDuplicate: true,
      originalTitle: template?.filter_template_name,
    });
    setCurrentTab("first");
    setQuickFilterModalVisible({ state: false, type: "duplicate" });
  };

  const handleModalVisiblility = (value) => {
    if (templateEdit.forDuplicate) {
      setQuickFilterModalVisible({ state: true, type: "duplicate" });
      setTemplateEdit({
        ...templateEdit,
        forEdit: false,
        forDuplicate: true,
      });
    } else {
      setQuickFilterModalVisible({ state: true, type: value || null });
    }
    createFilteredArray();
  };

  const saveEdited = () => {
    let updatedPayload = createFilteredArray();
    if (updatedPayload.length) {
      dispatch(
        updateFilterTemplate(
          authParams,
          panes,
          index,
          filterTemplatePayload.id,
          updatedPayload
        )
      );
      setTemplateEdit({ ...templateEdit, forEdit: false });
      setCurrentTab("second");
      // to unselect the filter pill
      // dispatch(setSelectedPillInPane({}, index, panes));
      let paneObj = {
        panes: panes,
        activeKey: activeKey,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        singleBrands: brands,
        authParams: authParams,
        index: index,
        competitorBrands: competitorBrands,
        graphConditionConfig: graphConditionConfig,
        is_modified_date:
          panes?.[index]?.template_id === "000-000-002" ||
          panes?.[index]?.template_id === "000-000-004"
            ? panes?.[index]?.is_modified_date
              ? panes?.[index]?.is_modified_date
              : false
            : null,
      };
      if (
        "selected_pills" in panes[index] &&
        panes[index]?.selected_pills.length &&
        filterTemplatePayload?.id ===
          panes[index]?.selected_pills[0]?.filter_template_id
      ) {
        let updatedPillObj = {
          filter_template_name: filterTemplatePayload.title,
          filter_template_description: filterTemplatePayload.description,
          filter_template_id: filterTemplatePayload.id,
          saved_filters: [...updatedPayload],
        };
        dispatch(setSelectedPillInPane(updatedPillObj, index, panes));
        dispatch(setClearGraphData(index, panes, paneObj));
      }
    }
  };

  const handleTitleInputChange = (e) => {
    const newValue = e.target.value;
    setTitleInputValue(newValue);
    setFilterTemplatePayload((prev) => ({
      ...prev,
      title: newValue,
    }));
  };

  const handleEditTemplate = (template) => {
    resetStateForTemplate(template.saved_filters);
    setFilterTemplatePayload({
      title: template?.filter_template_name,
      id: template?.filter_template_id,
      description: template?.filter_template_description,
      payload: template?.saved_filters,
    });
    setTemplateEdit({ ...templateEdit, forEdit: true });
    setCurrentTab("first");
  };

  const setPinFilters = () => {
    if (filterTemplates?.length) {
      if (Object.keys(quickFilterChecked).length > 0) {
        let selectedFilterTemplates = Object.keys(quickFilterChecked).filter(
          (key) => quickFilterChecked[key]
        );
        if (
          selectedPill &&
          selectedPill.length &&
          Object.keys(selectedPill[0]).length &&
          !quickFilterChecked[selectedPill[0].filter_template_id]
        ) {
          let indexOfPinnedAndUncheckedTemplate =
            pinnedFilterTemplates.findIndex(
              (item) =>
                item.filter_template_id == selectedPill[0].filter_template_id
            );
          if (indexOfPinnedAndUncheckedTemplate > -1) {
            dispatch(setSelectedPillInPane({}, index, panes));
          }
          let paneObj = {
            panes: panes,
            activeKey: activeKey,
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            singleBrands: brands,
            authParams: authParams,
            index: index,
            competitorBrands: competitorBrands,
            graphConditionConfig: graphConditionConfig,
            is_modified_date:
              panes?.[index]?.template_id === "000-000-002" ||
              panes?.[index]?.template_id === "000-000-004"
                ? panes?.[index]?.is_modified_date
                  ? panes?.[index]?.is_modified_date
                  : false
                : null,
          };
          dispatch(setClearGraphData(index, panes, paneObj));
        }
        if (
          !selectedFilterTemplates.includes(
            props.selectedTemplatePill?.filter_template_id
          )
        ) {
          props.setSelectedTemplatePill(null);
        }
        dispatch(
          setPinFilterTemplate(
            authParams,
            panes,
            index,
            selectedFilterTemplates
          )
        );
      } else if (pinnedFilterTemplates?.length) {
        dispatch(setSelectedPillInPane({}, index, panes));
        props.setSelectedTemplatePill(null); // to remove selected state of pill
        let paneObj = {
          panes: panes,
          activeKey: activeKey,
          brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
          singleBrands: brands,
          authParams: authParams,
          index: index,
          competitorBrands: competitorBrands,
          graphConditionConfig: graphConditionConfig,
          is_modified_date:
            panes?.[index]?.template_id === "000-000-002" ||
            panes?.[index]?.template_id === "000-000-004"
              ? panes?.[index]?.is_modified_date
                ? panes?.[index]?.is_modified_date
                : false
              : null,
        };
        dispatch(setClearGraphData(index, panes, paneObj));
        dispatch(setPinFilterTemplate(authParams, panes, index, []));
      }
      dispatch(setisFilterPanelVisible(false));
    }
  };

  if (drawer) {
    return (
      <>
        <Drawer
          title={<div style={{ paddingLeft: "1.5rem" }}></div>}
          placement="right"
          width={450} //520
          onClose={() => onfilterclear()}
          visible={visible}
          className={`Filters_Popup closeBtn_parent ${
            authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
          } quick_filter_body`}
          bodyStyle={{
            padding: 0,
          }}
          footer={
            currentTab === "first" ? (
              <div className="d-flex justify-content-between">
                {!quickFilterModalVisible?.state &&
                !templateEdit?.forEdit &&
                !templateEdit?.forDuplicate &&
                (GlobalFilter?.length || savedFilters?.length) &&
                JSON.stringify(GlobalFilter) !==
                  JSON.stringify(comHiddenFilter) ? (
                  <Button
                    onClick={() => {
                      onFilterClear();
                    }}
                    className="btn_Clear ClearFilterthemed"
                  >
                    Clear Filter
                  </Button>
                ) : (
                  <Tooltip title={"No filter applied"}>
                    {" "}
                    <Button
                      className="btn_Clear ClearFilterThemedDisabled"
                      style={{ opacity: "0.5", cursor: "not-allowed" }}
                    >
                      Clear Filter
                    </Button>
                  </Tooltip>
                )}
                <div className="d-flex">
                  {!quickFilterModalVisible?.state &&
                    !templateEdit?.forEdit &&
                    !templateEdit?.forDuplicate &&
                    showQuickFilter && (
                      <Button
                        className="btn_Clear CancelFilterthemed mr-15"
                        onClick={() => onfilterclear()}
                      >
                        Cancel
                      </Button>
                    )}
                  {(pathName === "dashboard" ||
                    (pathName === "pin-dashboard" &&
                      !quickFilterModalVisible?.state)) &&
                  showQuickFilter ? (
                    <Tooltip
                      title={
                        templateEdit?.forEdit && !isAnyFilterApplied
                          ? "No filter applied"
                          : ""
                      }
                    >
                      <Button
                        onClick={
                          templateEdit?.forEdit && isAnyFilterApplied
                            ? saveEdited
                            : templateEdit?.forEdit && !isAnyFilterApplied
                            ? undefined
                            : handleModalVisiblility
                        }
                        style={{
                          opacity: `${
                            templateEdit?.forEdit && !isAnyFilterApplied
                              ? ".5"
                              : "1"
                          }`,
                        }}
                        type="primary"
                        className="ant-btn-primary_blue mr-3"
                      >
                        {templateEdit?.forEdit
                          ? "Save"
                          : templateEdit.forDuplicate
                          ? "Save as duplicate"
                          : "Save as Quick Filter"}
                      </Button>
                    </Tooltip>
                  ) : (
                    ""
                  )}
                  {!quickFilterModalVisible?.state &&
                    !templateEdit?.forEdit &&
                    !templateEdit?.forDuplicate && (
                      <Button
                        onClick={onSubmit}
                        type="primary"
                        className="ant-btn-primary_blue"
                      >
                        Apply
                      </Button>
                    )}
                </div>
              </div>
            ) : (
              <QuickFilterFooter
                setQuickFilterChecked={setQuickFilterChecked}
                setSelectedCount={setSelectedCount}
                filterTemplates={filterTemplates}
                selectedCount={selectedCount}
                setPinFilters={setPinFilters}
              />
            )
          }
        >
          <Tabs
            className={`${
              (!showQuickFilter &&
                window.location.pathname.split("/")[1].toLowerCase() !==
                  "dashboard" &&
                window.location.pathname.split("/")[1].toLowerCase() !==
                  "pin-dashboard") ||
              authParams?.screen_id ||
              shareTemplateData !== null
                ? "filter-tab"
                : showQuickFilter &&
                  (window.location.pathname.split("/")[1].toLowerCase() ==
                    "dashboard" ||
                    window.location.pathname.split("/")[1].toLowerCase() ==
                      "pin-dashboard") &&
                  shareTemplateData == null
                ? "main-filter-tab"
                : showQuickFilter &&
                  window.location.pathname.split("/")[1].toLowerCase() !==
                    "dashboard" &&
                  window.location.pathname.split("/")[1].toLowerCase() !==
                    "pin-dashboard"
                ? " filter-tab"
                : (!showQuickFilter &&
                    window.location.pathname.split("/")[1].toLowerCase() ==
                      "dashboard") ||
                  window.location.pathname.split("/")[1].toLowerCase() ==
                    "pin-dashboard"
                ? " filter-tab"
                : ""
            }${authParams?.screen_id ? " filter-tab-cmd" : ""}`}
            style={{
              display: "flex",
              justifyContent: "center",
              width: "auto",
            }}
            activeKey={currentTab}
            onChange={handleTabChange}
          >
            <TabPane
              tab={
                <>
                  <div className="d-flex align-items-center line-height-normal">
                    {authParams?.screen_id === "000-000-557" ? (
                      ""
                    ) : (
                      <img
                        src={
                          authParams?.theme_type === "1"
                            ? filterSmallWhite
                            : filterSmall
                        }
                        alt="Filters"
                      />
                    )}
                    <div className="portlet__title ml-2 line-height-normal">
                      {authParams?.screen_id === "000-000-557"
                        ? "Add New Column"
                        : panes[getPaneIndex(panes, activeKeys)].template_id ===
                          "000-000-003"
                        ? `Filters`
                        : `Filters`}
                      {authParams?.screen_id === "000-000-563" ? (
                        <Tooltip
                          title={
                            "Filters will only apply to the Influencer Author Node, focusing the data on relevant relationships, metrics, and attributes for a more targeted analysis"
                          }
                        >
                          <i
                            className="fa fa-info-circle cursor-pointer ml-2"
                            style={{ color: "#A020F0" }}
                          />
                        </Tooltip>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </>
              }
              key="first"
            >
              {/* Dashboard Flow */}
              {/* <div className="p-10">
                <Input
                  size="large"
                  placeholder="Search"
                  onChange={onSearch}
                  value={filterSearch}
                  suffix={
                    <img
                      src={
                        authParams?.theme_type === "1"
                          ? searchWhite_icon
                          : search
                      }
                      alt="filter Search"
                      style={{ maxWidth: "2.5rem" }}
                    />
                  }
                  className=" border-color"
                />
              </div> */}

              {visible && (
                <Filters
                  filterSearchTermE={filterSearchTermE}
                  filterSearchTermIndexArray={filterSearchTermIndex}
                  activeKey={activeKey}
                  inputVal={inputVal}
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                  collapseChange={collapseChange}
                  ondateChange={ondateChange}
                  onradioChange={onradioChange}
                  onInputValChanges={onInputValChanges}
                  radio={radioChecked[type]?.data}
                  onAfterChange={onAfterChange}
                  slider={slider}
                  onShouldContain={onShouldContain}
                  attribute={attribute}
                  onOR={onOR}
                  onDonotHave={onDonotHave}
                  filterSearch={filterSearch}
                  handleCheckboxChange={handleCheckboxChange}
                  predefined={
                    type === "widgetMaker" ||
                    type?.split("_")[0] === "kpi" ||
                    type?.split("_")[0] === "y" ||
                    type === "command_center_global" ||
                    type === "command_center_section" ||
                    type === "command_center_widget"
                      ? false
                      : shareBrands && shareTemplateData
                      ? shareTemplateData?.predefined &&
                        shareTemplateData?.template_type !== "ticket" &&
                        shareTemplateData.template_id !== "000-000-002" &&
                        shareTemplateData.template_id !== "000-000-003"
                        ? false
                        : shareTemplateData?.predefined
                        ? shareTemplateData?.predefined
                        : false
                      : panes[getPaneIndex(panes, activeTabKey)].predefined &&
                        panes[getPaneIndex(panes, activeTabKey)]
                          ?.template_type !== "ticket" &&
                        panes[getPaneIndex(panes, activeTabKey)].template_id !==
                          "000-000-002" &&
                        panes[getPaneIndex(panes, activeTabKey)].template_id !==
                          "000-000-003"
                      ? false
                      : panes[getPaneIndex(panes, activeTabKey)].predefined
                      ? panes[getPaneIndex(panes, activeTabKey)].predefined
                      : false
                  }
                  templateId={
                    panes[getPaneIndex(panes, activeTabKey)].template_id
                  }
                  boolRadioChecked={boolRadioChecked}
                  checkedState={checkedState}
                  handleRadioOptionsChange={handleRadioOptionsChange}
                  handleSelectAllChange={handleSelectAllChange}
                  widgetMakerClearFilter={widgetMakerClearFilter}
                  textAtt={textAtt}
                  type={type}
                  setTextAtt={setTextAtt}
                  inputValArr={inputValArr}
                  setInputValArr={setInputValArr}
                  setInputVal={setInputVal}
                  setBoolRadioChecked={setBoolRadioChecked}
                  onSearch={onSearch}
                />
              )}
            </TabPane>
            {showQuickFilter &&
            (window.location.pathname?.split("/")[1]?.toLowerCase() ===
              "dashboard" ||
              window.location.pathname?.split("/")[1]?.toLowerCase() ===
                "pin-dashboard") &&
            shareTemplateData == null ? (
              <TabPane
                style={{
                  paddingLeft: "1.5rem",
                  overflow: "auto",
                  height: "calc(100vh - 100px)",
                  paddingBottom: "2rem",
                }}
                tab={
                  <div className="d-flex align-items-center line-height-normal">
                    <img src={quickfiltericon} alt="Filters" />
                    <div className="portlet__title ml-2 line-height-normal">
                      {`Quick Filters`}
                    </div>
                  </div>
                }
                key="second"
              >
                <div className="m-2 ml-minus-7-imprtant">
                  <Input
                    size="large"
                    placeholder="Search"
                    onChange={onSearch}
                    value={filterSearch}
                    suffix={
                      <img
                        src={
                          authParams?.theme_type === "1"
                            ? searchWhite_icon
                            : search
                        }
                        alt="filter Search"
                        style={{ maxWidth: "2.5rem" }}
                      />
                    }
                    className="border-color"
                  />
                </div>
                {filterTemplates?.length ? (
                  <QuickFilterTemplate
                    filterTemplates={filterTemplates}
                    filterSearch={filterSearch}
                    selectedCount={selectedCount}
                    quickFilterChecked={quickFilterChecked}
                    handleTemplateCheckboxChange={handleTemplateCheckboxChange}
                    handleDuplicateTemplate={handleDuplicateTemplate}
                    handleEditTemplate={handleEditTemplate}
                    handleDeleteTemplate={handleDeleteTemplate}
                  />
                ) : (
                  ""
                )}
                {(filterTemplates?.length == 0 ||
                  filterTemplates?.filter((item) =>
                    item?.filter_template_name
                      ?.toLowerCase()
                      .includes(filterSearch?.trim()?.toLowerCase() || "")
                  )?.length == 0) &&
                  !templateLoader && <QuickFilterNotFound />}
              </TabPane>
            ) : (
              " "
            )}
          </Tabs>
        </Drawer>
        {quickFilterModalVisible?.state && (
          <Popover
            placement="bottomRight"
            width={550}
            content={
              <QuickFilterInfoForm
                showDescriptionBox={showDescriptionBox}
                titleInputValue={titleInputValue}
                handleTitleInputChange={handleTitleInputChange}
                setShowDescriptionBox={setShowDescriptionBox}
                filterTemplatePayload={filterTemplatePayload}
                setFilterTemplatePayload={setFilterTemplatePayload}
                handleModalCancel={handleModalCancel}
                handleSave={handleSave}
                templateEdit={templateEdit}
              />
            }
            title={null}
            trigger="click"
            visible={quickFilterModalVisible?.state}
            onVisibleChange={setQuickFilterModalVisible}
          />
        )}
        {deleteTemplateDetails?.showModal && (
          <QuickFilterDeleteModal
            deleteTemplateDetails={deleteTemplateDetails}
            handleOk={handleOk}
            handleCancel={handleCancel}
          />
        )}
      </>
    );
  } else {
    return (
      <>
        {/* Widget Maker Flow */}
        {/* <div className="p-15">
          <Input
            size="large"
            placeholder="Search"
            onChange={onSearch}
            value={filterSearch}
            suffix={
              <img
                src={authParams?.theme_type === "1" ? searchWhite_icon : search}
                alt="search"
                style={{ maxWidth: "2.5rem" }}
              />
            }
            className="border-color"
          />
        </div> */}
        <Filters
          filterSearchTermE={filterSearchTermE}
          filterSearchTermIndexArray={filterSearchTermIndex}
          activeKey={activeKey}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          collapseChange={collapseChange}
          ondateChange={ondateChange}
          onradioChange={onradioChange}
          inputVal={inputVal}
          onInputValChanges={onInputValChanges}
          radio={radioChecked[type]?.data}
          onAfterChange={onAfterChange}
          slider={slider}
          onShouldContain={onShouldContain}
          attribute={attribute}
          onOR={onOR}
          onDonotHave={onDonotHave}
          filterSearch={filterSearch}
          handleCheckboxChange={handleCheckboxChange}
          predefined={
            type === "widgetMaker" ||
            type?.split("_")[0] === "kpi" ||
            type?.split("_")[0] === "y" ||
            type === "command_center_global" ||
            type === "command_center_section" ||
            type === "command_center_widget"
              ? false
              : shareBrands && shareTemplateData
              ? shareTemplateData?.predefined &&
                shareTemplateData?.template_type !== "ticket" &&
                shareTemplateData.template_id !== "000-000-002" &&
                shareTemplateData.template_id !== "000-000-003"
                ? false
                : shareTemplateData?.predefined
                ? shareTemplateData?.predefined
                : false
              : panes[getPaneIndex(panes, activeTabKey)].predefined &&
                panes[getPaneIndex(panes, activeTabKey)]?.template_type !==
                  "ticket" &&
                panes[getPaneIndex(panes, activeTabKey)].template_id !==
                  "000-000-002" &&
                panes[getPaneIndex(panes, activeTabKey)].template_id !==
                  "000-000-003"
              ? false
              : panes[getPaneIndex(panes, activeTabKey)].predefined
              ? true
              : false
          }
          boolRadioChecked={boolRadioChecked}
          checkedState={checkedState}
          handleRadioOptionsChange={handleRadioOptionsChange}
          handleSelectAllChange={handleSelectAllChange}
          widgetMakerClearFilter={widgetMakerClearFilter}
          textAtt={textAtt}
          type={type}
          setTextAtt={setTextAtt}
          inputValArr={inputValArr}
          setInputValArr={setInputValArr}
          setInputVal={setInputVal}
          setBoolRadioChecked={setBoolRadioChecked}
          onSearch={onSearch}
        />
      </>
    );
  }
};

export default FilterDrawer;
